import {Component} from 'inferno';


export class MapSVG extends Component<jsx.Props, jsx.State> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="mapSVG">
                <div dangerouslySetInnerHTML={{__html: backgroundMap}}/>
                {this.props.enableAnimation && <div
                    dangerouslySetInnerHTML={{__html: blinkingMap}}
                />}
            </div>
        );
    }
}

const blinkingMap = `
<svg id="blinkingMap" x="0px" y="0px"
viewBox="4 31.5 92 48.5">
<g>
<circle cx="27.3" cy="52.7" r="0.2"></circle> <!–– us-nyc ––>
<circle cx="28.8" cy="67.5" r="0.2"></circle> <!–– chile ––>
<circle cx="72.3" cy="51.2" r="0.2"></circle> <!–– central-asia ––>
<circle cx="34.7" cy="65.3" r="0.2"></circle> <!–– brazil ––>
<circle cx="80.5" cy="69" r="0.2"></circle> <!–– australia ––>
<circle cx="47.3" cy="52" r="0.2"></circle> <!–– europe ––>
<circle cx="22.1" cy="49.8" r="0.2"></circle> <!–– canada-middle ––>
<circle cx="59.8" cy="57.9" r="0.2"></circle> <!–– middle-east ––>
</g>
</svg>
`;


const backgroundMap = `
<svg id="backgroundMap" x="0px" y="0px"
viewBox="4 31.5 92 48.5">
<style>
    circle {
        fill:#e5e5e5;
        stroke:#e5e5e5;
        stroke-width:0.1;
    }
</style>
<g>
<circle cx="28.8" cy="79.3" r="0.2"/>
<circle cx="28.8" cy="78.6" r="0.2"/>
<circle cx="29.5" cy="78.6" r="0.2"/>
<circle cx="28" cy="77.9" r="0.2"/>
<circle cx="28.8" cy="77.9" r="0.2"/>
<circle cx="29.5" cy="77.9" r="0.2"/>
<circle cx="30.3" cy="77.9" r="0.2"/>
<circle cx="28.8" cy="77.1" r="0.2"/>
<circle cx="29.5" cy="77.1" r="0.2"/>
<circle cx="28.8" cy="76.4" r="0.2"/>
<circle cx="29.5" cy="76.4" r="0.2"/>
<circle cx="30.3" cy="76.4" r="0.2"/>
<circle cx="28.8" cy="75.6" r="0.2"/>
<circle cx="29.5" cy="75.6" r="0.2"/>
<circle cx="30.3" cy="75.6" r="0.2"/>
<circle cx="31" cy="75.6" r="0.2"/>
<circle cx="28.8" cy="74.9" r="0.2"/>
<circle cx="29.5" cy="74.9" r="0.2"/>
<circle cx="30.3" cy="74.9" r="0.2"/>
<circle cx="31" cy="74.9" r="0.2"/>
<circle cx="31.7" cy="74.9" r="0.2"/>
<circle cx="32.5" cy="74.9" r="0.2"/>
<circle cx="28.8" cy="74.2" r="0.2"/>
<circle cx="29.5" cy="74.2" r="0.2"/>
<circle cx="30.3" cy="74.2" r="0.2"/>
<circle cx="31" cy="74.2" r="0.2"/>
<circle cx="31.7" cy="74.2" r="0.2"/>
<circle cx="32.5" cy="74.2" r="0.2"/>
<circle cx="29.5" cy="73.4" r="0.2"/>
<circle cx="30.3" cy="73.4" r="0.2"/>
<circle cx="31" cy="73.4" r="0.2"/>
<circle cx="31.7" cy="73.4" r="0.2"/>
<circle cx="32.5" cy="73.4" r="0.2"/>
<circle cx="33.2" cy="73.4" r="0.2"/>
<circle cx="28.8" cy="72.7" r="0.2"/>
<circle cx="29.5" cy="72.7" r="0.2"/>
<circle cx="30.3" cy="72.7" r="0.2"/>
<circle cx="31" cy="72.7" r="0.2"/>
<circle cx="31.7" cy="72.7" r="0.2"/>
<circle cx="32.5" cy="72.7" r="0.2"/>
<circle cx="33.2" cy="72.7" r="0.2"/>
<circle cx="34" cy="72.7" r="0.2"/>
<circle cx="29.5" cy="71.9" r="0.2"/>
<circle cx="30.3" cy="71.9" r="0.2"/>
<circle cx="31" cy="71.9" r="0.2"/>
<circle cx="31.7" cy="71.9" r="0.2"/>
<circle cx="32.5" cy="71.9" r="0.2"/>
<circle cx="33.2" cy="71.9" r="0.2"/>
<circle cx="34" cy="71.9" r="0.2"/>
<circle cx="34.7" cy="71.9" r="0.2"/>
<circle cx="29.5" cy="71.2" r="0.2"/>
<circle cx="30.3" cy="71.2" r="0.2"/>
<circle cx="31" cy="71.2" r="0.2"/>
<circle cx="31.7" cy="71.2" r="0.2"/>
<circle cx="32.5" cy="71.2" r="0.2"/>
<circle cx="33.2" cy="71.2" r="0.2"/>
<circle cx="34" cy="71.2" r="0.2"/>
<circle cx="34.7" cy="71.2" r="0.2"/>
<circle cx="29.5" cy="70.5" r="0.2"/>
<circle cx="30.3" cy="70.5" r="0.2"/>
<circle cx="31" cy="70.5" r="0.2"/>
<circle cx="31.7" cy="70.5" r="0.2"/>
<circle cx="32.5" cy="70.5" r="0.2"/>
<circle cx="33.2" cy="70.5" r="0.2"/>
<circle cx="34" cy="70.5" r="0.2"/>
<circle cx="34.7" cy="70.5" r="0.2"/>
<circle cx="29.5" cy="69.7" r="0.2"/>
<circle cx="30.3" cy="69.7" r="0.2"/>
<circle cx="31" cy="69.7" r="0.2"/>
<circle cx="31.7" cy="69.7" r="0.2"/>
<circle cx="32.5" cy="69.7" r="0.2"/>
<circle cx="33.2" cy="69.7" r="0.2"/>
<circle cx="34" cy="69.7" r="0.2"/>
<circle cx="34.7" cy="69.7" r="0.2"/>
<circle cx="35.4" cy="69.7" r="0.2"/>
<circle cx="36.2" cy="69.7" r="0.2"/>
<circle cx="36.9" cy="69.7" r="0.2"/>
<circle cx="29.5" cy="69" r="0.2"/>
<circle cx="30.3" cy="69" r="0.2"/>
<circle cx="31" cy="69" r="0.2"/>
<circle cx="31.7" cy="69" r="0.2"/>
<circle cx="32.5" cy="69" r="0.2"/>
<circle cx="33.2" cy="69" r="0.2"/>
<circle cx="34" cy="69" r="0.2"/>
<circle cx="34.7" cy="69" r="0.2"/>
<circle cx="35.4" cy="69" r="0.2"/>
<circle cx="36.2" cy="69" r="0.2"/>
<circle cx="36.9" cy="69" r="0.2"/>
<circle cx="28" cy="68.2" r="0.2"/>
<circle cx="28.8" cy="68.2" r="0.2"/>
<circle cx="29.5" cy="68.2" r="0.2"/>
<circle cx="30.3" cy="68.2" r="0.2"/>
<circle cx="31" cy="68.2" r="0.2"/>
<circle cx="31.7" cy="68.2" r="0.2"/>
<circle cx="32.5" cy="68.2" r="0.2"/>
<circle cx="33.2" cy="68.2" r="0.2"/>
<circle cx="34" cy="68.2" r="0.2"/>
<circle cx="34.7" cy="68.2" r="0.2"/>
<circle cx="35.4" cy="68.2" r="0.2"/>
<circle cx="36.2" cy="68.2" r="0.2"/>
<circle cx="36.9" cy="68.2" r="0.2"/>
<circle cx="28" cy="67.5" r="0.2"/>
<circle cx="28.8" cy="67.5" r="0.2"/>
<circle cx="29.5" cy="67.5" r="0.2"/>
<circle cx="30.3" cy="67.5" r="0.2"/>
<circle cx="31" cy="67.5" r="0.2"/>
<circle cx="31.7" cy="67.5" r="0.2"/>
<circle cx="32.5" cy="67.5" r="0.2"/>
<circle cx="33.2" cy="67.5" r="0.2"/>
<circle cx="34" cy="67.5" r="0.2"/>
<circle cx="34.7" cy="67.5" r="0.2"/>
<circle cx="35.4" cy="67.5" r="0.2"/>
<circle cx="36.2" cy="67.5" r="0.2"/>
<circle cx="36.9" cy="67.5" r="0.2"/>
<circle cx="27.3" cy="66.8" r="0.2"/>
<circle cx="28" cy="66.8" r="0.2"/>
<circle cx="28.8" cy="66.8" r="0.2"/>
<circle cx="29.5" cy="66.8" r="0.2"/>
<circle cx="30.3" cy="66.8" r="0.2"/>
<circle cx="31" cy="66.8" r="0.2"/>
<circle cx="31.7" cy="66.8" r="0.2"/>
<circle cx="32.5" cy="66.8" r="0.2"/>
<circle cx="33.2" cy="66.8" r="0.2"/>
<circle cx="34" cy="66.8" r="0.2"/>
<circle cx="34.7" cy="66.8" r="0.2"/>
<circle cx="35.4" cy="66.8" r="0.2"/>
<circle cx="36.2" cy="66.8" r="0.2"/>
<circle cx="36.9" cy="66.8" r="0.2"/>
<circle cx="37.7" cy="66.8" r="0.2"/>
<circle cx="27.3" cy="66" r="0.2"/>
<circle cx="28" cy="66" r="0.2"/>
<circle cx="28.8" cy="66" r="0.2"/>
<circle cx="29.5" cy="66" r="0.2"/>
<circle cx="30.3" cy="66" r="0.2"/>
<circle cx="31" cy="66" r="0.2"/>
<circle cx="31.7" cy="66" r="0.2"/>
<circle cx="32.5" cy="66" r="0.2"/>
<circle cx="33.2" cy="66" r="0.2"/>
<circle cx="34" cy="66" r="0.2"/>
<circle cx="34.7" cy="66" r="0.2"/>
<circle cx="35.4" cy="66" r="0.2"/>
<circle cx="36.2" cy="66" r="0.2"/>
<circle cx="36.9" cy="66" r="0.2"/>
<circle cx="37.7" cy="66" r="0.2"/>
<circle cx="38.4" cy="66" r="0.2"/>
<circle cx="26.6" cy="65.3" r="0.2"/>
<circle cx="27.3" cy="65.3" r="0.2"/>
<circle cx="28" cy="65.3" r="0.2"/>
<circle cx="28.8" cy="65.3" r="0.2"/>
<circle cx="29.5" cy="65.3" r="0.2"/>
<circle cx="30.3" cy="65.3" r="0.2"/>
<circle cx="31" cy="65.3" r="0.2"/>
<circle cx="31.7" cy="65.3" r="0.2"/>
<circle cx="32.5" cy="65.3" r="0.2"/>
<circle cx="33.2" cy="65.3" r="0.2"/>
<circle cx="34" cy="65.3" r="0.2"/>
<circle cx="34.7" cy="65.3" r="0.2"/>
<circle cx="35.4" cy="65.3" r="0.2"/>
<circle cx="36.2" cy="65.3" r="0.2"/>
<circle cx="36.9" cy="65.3" r="0.2"/>
<circle cx="26.6" cy="64.5" r="0.2"/>
<circle cx="27.3" cy="64.5" r="0.2"/>
<circle cx="28" cy="64.5" r="0.2"/>
<circle cx="28.8" cy="64.5" r="0.2"/>
<circle cx="29.5" cy="64.5" r="0.2"/>
<circle cx="30.3" cy="64.5" r="0.2"/>
<circle cx="31" cy="64.5" r="0.2"/>
<circle cx="31.7" cy="64.5" r="0.2"/>
<circle cx="32.5" cy="64.5" r="0.2"/>
<circle cx="33.2" cy="64.5" r="0.2"/>
<circle cx="34" cy="64.5" r="0.2"/>
<circle cx="34.7" cy="64.5" r="0.2"/>
<circle cx="35.4" cy="64.5" r="0.2"/>
<circle cx="49.5" cy="64.5" r="0.2"/>
<circle cx="27.3" cy="63.8" r="0.2"/>
<circle cx="28" cy="63.8" r="0.2"/>
<circle cx="28.8" cy="63.8" r="0.2"/>
<circle cx="29.5" cy="63.8" r="0.2"/>
<circle cx="30.3" cy="63.8" r="0.2"/>
<circle cx="31" cy="63.8" r="0.2"/>
<circle cx="31.7" cy="63.8" r="0.2"/>
<circle cx="32.5" cy="63.8" r="0.2"/>
<circle cx="33.2" cy="63.8" r="0.2"/>
<circle cx="34" cy="63.8" r="0.2"/>
<circle cx="28" cy="63.1" r="0.2"/>
<circle cx="28.8" cy="63.1" r="0.2"/>
<circle cx="29.5" cy="63.1" r="0.2"/>
<circle cx="30.3" cy="63.1" r="0.2"/>
<circle cx="31" cy="63.1" r="0.2"/>
<circle cx="31.7" cy="63.1" r="0.2"/>
<circle cx="32.5" cy="63.1" r="0.2"/>
<circle cx="33.2" cy="63.1" r="0.2"/>
<circle cx="34" cy="63.1" r="0.2"/>
<circle cx="45" cy="63.1" r="0.2"/>
<circle cx="46.5" cy="63.1" r="0.2"/>
<circle cx="48.8" cy="63.1" r="0.2"/>
<circle cx="26.6" cy="62.3" r="0.2"/>
<circle cx="27.3" cy="62.3" r="0.2"/>
<circle cx="28" cy="62.3" r="0.2"/>
<circle cx="28.8" cy="62.3" r="0.2"/>
<circle cx="29.5" cy="62.3" r="0.2"/>
<circle cx="30.3" cy="62.3" r="0.2"/>
<circle cx="31" cy="62.3" r="0.2"/>
<circle cx="31.7" cy="62.3" r="0.2"/>
<circle cx="44.3" cy="62.3" r="0.2"/>
<circle cx="45" cy="62.3" r="0.2"/>
<circle cx="45.8" cy="62.3" r="0.2"/>
<circle cx="46.5" cy="62.3" r="0.2"/>
<circle cx="47.3" cy="62.3" r="0.2"/>
<circle cx="48" cy="62.3" r="0.2"/>
<circle cx="48.8" cy="62.3" r="0.2"/>
<circle cx="49.5" cy="62.3" r="0.2"/>
<circle cx="25.8" cy="61.6" r="0.2"/>
<circle cx="28" cy="61.6" r="0.2"/>
<circle cx="28.8" cy="61.6" r="0.2"/>
<circle cx="29.5" cy="61.6" r="0.2"/>
<circle cx="30.3" cy="61.6" r="0.2"/>
<circle cx="31" cy="61.6" r="0.2"/>
<circle cx="43.6" cy="61.6" r="0.2"/>
<circle cx="44.3" cy="61.6" r="0.2"/>
<circle cx="45" cy="61.6" r="0.2"/>
<circle cx="45.8" cy="61.6" r="0.2"/>
<circle cx="46.5" cy="61.6" r="0.2"/>
<circle cx="47.3" cy="61.6" r="0.2"/>
<circle cx="48" cy="61.6" r="0.2"/>
<circle cx="48.8" cy="61.6" r="0.2"/>
<circle cx="49.5" cy="61.6" r="0.2"/>
<circle cx="25.1" cy="60.8" r="0.2"/>
<circle cx="25.8" cy="60.8" r="0.2"/>
<circle cx="28.8" cy="60.8" r="0.2"/>
<circle cx="31.7" cy="60.8" r="0.2"/>
<circle cx="42.8" cy="60.8" r="0.2"/>
<circle cx="43.6" cy="60.8" r="0.2"/>
<circle cx="44.3" cy="60.8" r="0.2"/>
<circle cx="45" cy="60.8" r="0.2"/>
<circle cx="45.8" cy="60.8" r="0.2"/>
<circle cx="46.5" cy="60.8" r="0.2"/>
<circle cx="47.3" cy="60.8" r="0.2"/>
<circle cx="48" cy="60.8" r="0.2"/>
<circle cx="48.8" cy="60.8" r="0.2"/>
<circle cx="49.5" cy="60.8" r="0.2"/>
<circle cx="22.9" cy="60.1" r="0.2"/>
<circle cx="23.6" cy="60.1" r="0.2"/>
<circle cx="24.3" cy="60.1" r="0.2"/>
<circle cx="25.1" cy="60.1" r="0.2"/>
<circle cx="42.8" cy="60.1" r="0.2"/>
<circle cx="43.6" cy="60.1" r="0.2"/>
<circle cx="44.3" cy="60.1" r="0.2"/>
<circle cx="45" cy="60.1" r="0.2"/>
<circle cx="45.8" cy="60.1" r="0.2"/>
<circle cx="46.5" cy="60.1" r="0.2"/>
<circle cx="47.3" cy="60.1" r="0.2"/>
<circle cx="48" cy="60.1" r="0.2"/>
<circle cx="48.8" cy="60.1" r="0.2"/>
<circle cx="49.5" cy="60.1" r="0.2"/>
<circle cx="20.7" cy="59.4" r="0.2"/>
<circle cx="21.4" cy="59.4" r="0.2"/>
<circle cx="22.1" cy="59.4" r="0.2"/>
<circle cx="22.9" cy="59.4" r="0.2"/>
<circle cx="23.6" cy="59.4" r="0.2"/>
<circle cx="24.3" cy="59.4" r="0.2"/>
<circle cx="28.8" cy="59.4" r="0.2"/>
<circle cx="29.5" cy="59.4" r="0.2"/>
<circle cx="43.6" cy="59.4" r="0.2"/>
<circle cx="44.3" cy="59.4" r="0.2"/>
<circle cx="45" cy="59.4" r="0.2"/>
<circle cx="45.8" cy="59.4" r="0.2"/>
<circle cx="46.5" cy="59.4" r="0.2"/>
<circle cx="47.3" cy="59.4" r="0.2"/>
<circle cx="48" cy="59.4" r="0.2"/>
<circle cx="48.8" cy="59.4" r="0.2"/>
<circle cx="49.5" cy="59.4" r="0.2"/>
<circle cx="20.7" cy="58.6" r="0.2"/>
<circle cx="21.4" cy="58.6" r="0.2"/>
<circle cx="22.1" cy="58.6" r="0.2"/>
<circle cx="24.3" cy="58.6" r="0.2"/>
<circle cx="26.6" cy="58.6" r="0.2"/>
<circle cx="27.3" cy="58.6" r="0.2"/>
<circle cx="42.8" cy="58.6" r="0.2"/>
<circle cx="43.6" cy="58.6" r="0.2"/>
<circle cx="44.3" cy="58.6" r="0.2"/>
<circle cx="45" cy="58.6" r="0.2"/>
<circle cx="45.8" cy="58.6" r="0.2"/>
<circle cx="46.5" cy="58.6" r="0.2"/>
<circle cx="47.3" cy="58.6" r="0.2"/>
<circle cx="48" cy="58.6" r="0.2"/>
<circle cx="48.8" cy="58.6" r="0.2"/>
<circle cx="49.5" cy="58.6" r="0.2"/>
<circle cx="19.2" cy="57.9" r="0.2"/>
<circle cx="19.9" cy="57.9" r="0.2"/>
<circle cx="20.7" cy="57.9" r="0.2"/>
<circle cx="21.4" cy="57.9" r="0.2"/>
<circle cx="43.6" cy="57.9" r="0.2"/>
<circle cx="44.3" cy="57.9" r="0.2"/>
<circle cx="45" cy="57.9" r="0.2"/>
<circle cx="45.8" cy="57.9" r="0.2"/>
<circle cx="46.5" cy="57.9" r="0.2"/>
<circle cx="47.3" cy="57.9" r="0.2"/>
<circle cx="48" cy="57.9" r="0.2"/>
<circle cx="48.8" cy="57.9" r="0.2"/>
<circle cx="49.5" cy="57.9" r="0.2"/>
<circle cx="18.4" cy="57.1" r="0.2"/>
<circle cx="19.2" cy="57.1" r="0.2"/>
<circle cx="19.9" cy="57.1" r="0.2"/>
<circle cx="20.7" cy="57.1" r="0.2"/>
<circle cx="21.4" cy="57.1" r="0.2"/>
<circle cx="22.1" cy="57.1" r="0.2"/>
<circle cx="26.6" cy="57.1" r="0.2"/>
<circle cx="44.3" cy="57.1" r="0.2"/>
<circle cx="45.1" cy="57.1" r="0.2"/>
<circle cx="45.8" cy="57.1" r="0.2"/>
<circle cx="46.5" cy="57.1" r="0.2"/>
<circle cx="47.3" cy="57.1" r="0.2"/>
<circle cx="48" cy="57.1" r="0.2"/>
<circle cx="48.8" cy="57.1" r="0.2"/>
<circle cx="49.5" cy="57.1" r="0.2"/>
<circle cx="17.7" cy="56.4" r="0.2"/>
<circle cx="18.4" cy="56.4" r="0.2"/>
<circle cx="19.2" cy="56.4" r="0.2"/>
<circle cx="19.9" cy="56.4" r="0.2"/>
<circle cx="20.7" cy="56.4" r="0.2"/>
<circle cx="21.4" cy="56.4" r="0.2"/>
<circle cx="22.1" cy="56.4" r="0.2"/>
<circle cx="22.9" cy="56.4" r="0.2"/>
<circle cx="24.3" cy="56.4" r="0.2"/>
<circle cx="25.8" cy="56.4" r="0.2"/>
<circle cx="45.1" cy="56.4" r="0.2"/>
<circle cx="45.8" cy="56.4" r="0.2"/>
<circle cx="46.5" cy="56.4" r="0.2"/>
<circle cx="47.3" cy="56.4" r="0.2"/>
<circle cx="48" cy="56.4" r="0.2"/>
<circle cx="48.8" cy="56.4" r="0.2"/>
<circle cx="49.5" cy="56.4" r="0.2"/>
<circle cx="17.7" cy="55.7" r="0.2"/>
<circle cx="18.4" cy="55.7" r="0.2"/>
<circle cx="19.2" cy="55.7" r="0.2"/>
<circle cx="19.9" cy="55.7" r="0.2"/>
<circle cx="20.7" cy="55.7" r="0.2"/>
<circle cx="21.4" cy="55.7" r="0.2"/>
<circle cx="22.1" cy="55.7" r="0.2"/>
<circle cx="22.9" cy="55.7" r="0.2"/>
<circle cx="23.6" cy="55.7" r="0.2"/>
<circle cx="24.3" cy="55.7" r="0.2"/>
<circle cx="25.1" cy="55.7" r="0.2"/>
<circle cx="25.8" cy="55.7" r="0.2"/>
<circle cx="45.1" cy="55.7" r="0.2"/>
<circle cx="45.8" cy="55.7" r="0.2"/>
<circle cx="46.5" cy="55.7" r="0.2"/>
<circle cx="47.3" cy="55.7" r="0.2"/>
<circle cx="48" cy="55.7" r="0.2"/>
<circle cx="48.8" cy="55.7" r="0.2"/>
<circle cx="49.5" cy="55.7" r="0.2"/>
<circle cx="17.7" cy="54.9" r="0.2"/>
<circle cx="18.4" cy="54.9" r="0.2"/>
<circle cx="19.2" cy="54.9" r="0.2"/>
<circle cx="19.9" cy="54.9" r="0.2"/>
<circle cx="20.7" cy="54.9" r="0.2"/>
<circle cx="21.4" cy="54.9" r="0.2"/>
<circle cx="22.1" cy="54.9" r="0.2"/>
<circle cx="22.9" cy="54.9" r="0.2"/>
<circle cx="23.6" cy="54.9" r="0.2"/>
<circle cx="24.3" cy="54.9" r="0.2"/>
<circle cx="25.1" cy="54.9" r="0.2"/>
<circle cx="25.8" cy="54.9" r="0.2"/>
<circle cx="26.6" cy="54.9" r="0.2"/>
<circle cx="45.8" cy="54.9" r="0.2"/>
<circle cx="46.5" cy="54.9" r="0.2"/>
<circle cx="47.3" cy="54.9" r="0.2"/>
<circle cx="48" cy="54.9" r="0.2"/>
<circle cx="48.8" cy="54.9" r="0.2"/>
<circle cx="49.5" cy="54.9" r="0.2"/>
<circle cx="16.2" cy="54.2" r="0.2"/>
<circle cx="17" cy="54.2" r="0.2"/>
<circle cx="17.7" cy="54.2" r="0.2"/>
<circle cx="18.4" cy="54.2" r="0.2"/>
<circle cx="19.2" cy="54.2" r="0.2"/>
<circle cx="19.9" cy="54.2" r="0.2"/>
<circle cx="20.7" cy="54.2" r="0.2"/>
<circle cx="21.4" cy="54.2" r="0.2"/>
<circle cx="22.1" cy="54.2" r="0.2"/>
<circle cx="22.9" cy="54.2" r="0.2"/>
<circle cx="23.6" cy="54.2" r="0.2"/>
<circle cx="24.3" cy="54.2" r="0.2"/>
<circle cx="25.1" cy="54.2" r="0.2"/>
<circle cx="25.8" cy="54.2" r="0.2"/>
<circle cx="26.6" cy="54.2" r="0.2"/>
<circle cx="27.3" cy="54.2" r="0.2"/>
<circle cx="48.8" cy="54.2" r="0.2"/>
<circle cx="49.5" cy="54.2" r="0.2"/>
<circle cx="16.2" cy="53.5" r="0.2"/>
<circle cx="17" cy="53.5" r="0.2"/>
<circle cx="17.7" cy="53.5" r="0.2"/>
<circle cx="18.4" cy="53.5" r="0.2"/>
<circle cx="19.2" cy="53.5" r="0.2"/>
<circle cx="19.9" cy="53.5" r="0.2"/>
<circle cx="20.7" cy="53.5" r="0.2"/>
<circle cx="21.4" cy="53.5" r="0.2"/>
<circle cx="22.1" cy="53.5" r="0.2"/>
<circle cx="22.9" cy="53.5" r="0.2"/>
<circle cx="23.6" cy="53.5" r="0.2"/>
<circle cx="24.3" cy="53.5" r="0.2"/>
<circle cx="25.1" cy="53.5" r="0.2"/>
<circle cx="25.8" cy="53.5" r="0.2"/>
<circle cx="26.6" cy="53.5" r="0.2"/>
<circle cx="27.3" cy="53.5" r="0.2"/>
<circle cx="45.1" cy="53.5" r="0.2"/>
<circle cx="45.8" cy="53.5" r="0.2"/>
<circle cx="46.5" cy="53.5" r="0.2"/>
<circle cx="15.5" cy="52.7" r="0.2"/>
<circle cx="16.2" cy="52.7" r="0.2"/>
<circle cx="17" cy="52.7" r="0.2"/>
<circle cx="17.7" cy="52.7" r="0.2"/>
<circle cx="18.4" cy="52.7" r="0.2"/>
<circle cx="19.2" cy="52.7" r="0.2"/>
<circle cx="19.9" cy="52.7" r="0.2"/>
<circle cx="20.7" cy="52.7" r="0.2"/>
<circle cx="21.4" cy="52.7" r="0.2"/>
<circle cx="22.1" cy="52.7" r="0.2"/>
<circle cx="22.9" cy="52.7" r="0.2"/>
<circle cx="23.6" cy="52.7" r="0.2"/>
<circle cx="24.3" cy="52.7" r="0.2"/>
<circle cx="25.1" cy="52.7" r="0.2"/>
<circle cx="25.8" cy="52.7" r="0.2"/>
<circle cx="26.6" cy="52.7" r="0.2"/>
<circle cx="27.3" cy="52.7" r="0.2"/>
<circle cx="28.1" cy="52.7" r="0.2"/>
<circle cx="45.1" cy="52.7" r="0.2"/>
<circle cx="45.8" cy="52.7" r="0.2"/>
<circle cx="46.5" cy="52.7" r="0.2"/>
<circle cx="47.3" cy="52.7" r="0.2"/>
<circle cx="49.5" cy="52.7" r="0.2"/>
<circle cx="15.5" cy="52" r="0.2"/>
<circle cx="16.2" cy="52" r="0.2"/>
<circle cx="17" cy="52" r="0.2"/>
<circle cx="17.7" cy="52" r="0.2"/>
<circle cx="18.4" cy="52" r="0.2"/>
<circle cx="19.2" cy="52" r="0.2"/>
<circle cx="19.9" cy="52" r="0.2"/>
<circle cx="20.7" cy="52" r="0.2"/>
<circle cx="21.4" cy="52" r="0.2"/>
<circle cx="22.1" cy="52" r="0.2"/>
<circle cx="22.9" cy="52" r="0.2"/>
<circle cx="23.6" cy="52" r="0.2"/>
<circle cx="24.3" cy="52" r="0.2"/>
<circle cx="25.1" cy="52" r="0.2"/>
<circle cx="25.8" cy="52" r="0.2"/>
<circle cx="26.6" cy="52" r="0.2"/>
<circle cx="27.3" cy="52" r="0.2"/>
<circle cx="28.1" cy="52" r="0.2"/>
<circle cx="28.8" cy="52" r="0.2"/>
<circle cx="45.1" cy="52" r="0.2"/>
<circle cx="45.8" cy="52" r="0.2"/>
<circle cx="46.5" cy="52" r="0.2"/>
<circle cx="47.3" cy="52" r="0.2"/>
<circle cx="48" cy="52" r="0.2"/>
<circle cx="48.8" cy="52" r="0.2"/>
<circle cx="15.5" cy="51.2" r="0.2"/>
<circle cx="16.2" cy="51.2" r="0.2"/>
<circle cx="17" cy="51.2" r="0.2"/>
<circle cx="17.7" cy="51.2" r="0.2"/>
<circle cx="18.4" cy="51.2" r="0.2"/>
<circle cx="19.2" cy="51.2" r="0.2"/>
<circle cx="19.9" cy="51.2" r="0.2"/>
<circle cx="20.7" cy="51.2" r="0.2"/>
<circle cx="21.4" cy="51.2" r="0.2"/>
<circle cx="22.1" cy="51.2" r="0.2"/>
<circle cx="22.9" cy="51.2" r="0.2"/>
<circle cx="23.6" cy="51.2" r="0.2"/>
<circle cx="24.3" cy="51.2" r="0.2"/>
<circle cx="25.1" cy="51.2" r="0.2"/>
<circle cx="25.8" cy="51.2" r="0.2"/>
<circle cx="26.6" cy="51.2" r="0.2"/>
<circle cx="27.3" cy="51.2" r="0.2"/>
<circle cx="28.1" cy="51.2" r="0.2"/>
<circle cx="28.8" cy="51.2" r="0.2"/>
<circle cx="29.5" cy="51.2" r="0.2"/>
<circle cx="30.3" cy="51.2" r="0.2"/>
<circle cx="31" cy="51.2" r="0.2"/>
<circle cx="47.3" cy="51.2" r="0.2"/>
<circle cx="48" cy="51.2" r="0.2"/>
<circle cx="48.8" cy="51.2" r="0.2"/>
<circle cx="49.5" cy="51.2" r="0.2"/>
<circle cx="15.5" cy="50.5" r="0.2"/>
<circle cx="16.2" cy="50.5" r="0.2"/>
<circle cx="17" cy="50.5" r="0.2"/>
<circle cx="17.7" cy="50.5" r="0.2"/>
<circle cx="18.4" cy="50.5" r="0.2"/>
<circle cx="19.2" cy="50.5" r="0.2"/>
<circle cx="19.9" cy="50.5" r="0.2"/>
<circle cx="20.7" cy="50.5" r="0.2"/>
<circle cx="21.4" cy="50.5" r="0.2"/>
<circle cx="22.1" cy="50.5" r="0.2"/>
<circle cx="22.9" cy="50.5" r="0.2"/>
<circle cx="23.6" cy="50.5" r="0.2"/>
<circle cx="24.3" cy="50.5" r="0.2"/>
<circle cx="25.1" cy="50.5" r="0.2"/>
<circle cx="25.8" cy="50.5" r="0.2"/>
<circle cx="26.6" cy="50.5" r="0.2"/>
<circle cx="27.3" cy="50.5" r="0.2"/>
<circle cx="28.1" cy="50.5" r="0.2"/>
<circle cx="28.8" cy="50.5" r="0.2"/>
<circle cx="29.5" cy="50.5" r="0.2"/>
<circle cx="30.3" cy="50.5" r="0.2"/>
<circle cx="33.2" cy="50.5" r="0.2"/>
<circle cx="46.5" cy="50.5" r="0.2"/>
<circle cx="47.3" cy="50.5" r="0.2"/>
<circle cx="48" cy="50.5" r="0.2"/>
<circle cx="48.8" cy="50.5" r="0.2"/>
<circle cx="49.5" cy="50.5" r="0.2"/>
<circle cx="16.2" cy="49.8" r="0.2"/>
<circle cx="17" cy="49.8" r="0.2"/>
<circle cx="17.7" cy="49.8" r="0.2"/>
<circle cx="18.4" cy="49.8" r="0.2"/>
<circle cx="19.2" cy="49.8" r="0.2"/>
<circle cx="19.9" cy="49.8" r="0.2"/>
<circle cx="20.7" cy="49.8" r="0.2"/>
<circle cx="21.4" cy="49.8" r="0.2"/>
<circle cx="22.1" cy="49.8" r="0.2"/>
<circle cx="22.9" cy="49.8" r="0.2"/>
<circle cx="23.6" cy="49.8" r="0.2"/>
<circle cx="24.3" cy="49.8" r="0.2"/>
<circle cx="25.1" cy="49.8" r="0.2"/>
<circle cx="25.8" cy="49.8" r="0.2"/>
<circle cx="26.6" cy="49.8" r="0.2"/>
<circle cx="27.3" cy="49.8" r="0.2"/>
<circle cx="28.1" cy="49.8" r="0.2"/>
<circle cx="28.8" cy="49.8" r="0.2"/>
<circle cx="29.5" cy="49.8" r="0.2"/>
<circle cx="32.5" cy="49.8" r="0.2"/>
<circle cx="33.2" cy="49.8" r="0.2"/>
<circle cx="47.3" cy="49.8" r="0.2"/>
<circle cx="48" cy="49.8" r="0.2"/>
<circle cx="48.8" cy="49.8" r="0.2"/>
<circle cx="49.5" cy="49.8" r="0.2"/>
<circle cx="14.7" cy="49" r="0.2"/>
<circle cx="15.5" cy="49" r="0.2"/>
<circle cx="16.2" cy="49" r="0.2"/>
<circle cx="17" cy="49" r="0.2"/>
<circle cx="17.7" cy="49" r="0.2"/>
<circle cx="18.4" cy="49" r="0.2"/>
<circle cx="19.2" cy="49" r="0.2"/>
<circle cx="19.9" cy="49" r="0.2"/>
<circle cx="20.7" cy="49" r="0.2"/>
<circle cx="21.4" cy="49" r="0.2"/>
<circle cx="22.1" cy="49" r="0.2"/>
<circle cx="22.9" cy="49" r="0.2"/>
<circle cx="23.6" cy="49" r="0.2"/>
<circle cx="24.3" cy="49" r="0.2"/>
<circle cx="25.1" cy="49" r="0.2"/>
<circle cx="25.8" cy="49" r="0.2"/>
<circle cx="26.6" cy="49" r="0.2"/>
<circle cx="27.3" cy="49" r="0.2"/>
<circle cx="28.1" cy="49" r="0.2"/>
<circle cx="28.8" cy="49" r="0.2"/>
<circle cx="29.5" cy="49" r="0.2"/>
<circle cx="30.3" cy="49" r="0.2"/>
<circle cx="31" cy="49" r="0.2"/>
<circle cx="31.7" cy="49" r="0.2"/>
<circle cx="45.1" cy="49" r="0.2"/>
<circle cx="46.5" cy="49" r="0.2"/>
<circle cx="48" cy="49" r="0.2"/>
<circle cx="48.8" cy="49" r="0.2"/>
<circle cx="49.5" cy="49" r="0.2"/>
<circle cx="14.7" cy="48.4" r="0.2"/>
<circle cx="15.5" cy="48.4" r="0.2"/>
<circle cx="16.2" cy="48.4" r="0.2"/>
<circle cx="17" cy="48.4" r="0.2"/>
<circle cx="17.7" cy="48.4" r="0.2"/>
<circle cx="18.4" cy="48.4" r="0.2"/>
<circle cx="19.2" cy="48.4" r="0.2"/>
<circle cx="19.9" cy="48.4" r="0.2"/>
<circle cx="20.7" cy="48.4" r="0.2"/>
<circle cx="21.4" cy="48.4" r="0.2"/>
<circle cx="22.1" cy="48.4" r="0.2"/>
<circle cx="22.9" cy="48.4" r="0.2"/>
<circle cx="23.6" cy="48.4" r="0.2"/>
<circle cx="24.4" cy="48.4" r="0.2"/>
<circle cx="25.1" cy="48.4" r="0.2"/>
<circle cx="25.8" cy="48.4" r="0.2"/>
<circle cx="27.3" cy="48.4" r="0.2"/>
<circle cx="28.1" cy="48.4" r="0.2"/>
<circle cx="28.8" cy="48.4" r="0.2"/>
<circle cx="29.5" cy="48.4" r="0.2"/>
<circle cx="30.3" cy="48.4" r="0.2"/>
<circle cx="31" cy="48.4" r="0.2"/>
<circle cx="31.7" cy="48.4" r="0.2"/>
<circle cx="32.5" cy="48.4" r="0.2"/>
<circle cx="45.1" cy="48.4" r="0.2"/>
<circle cx="45.8" cy="48.4" r="0.2"/>
<circle cx="46.5" cy="48.4" r="0.2"/>
<circle cx="47.3" cy="48.4" r="0.2"/>
<circle cx="48.8" cy="48.4" r="0.2"/>
<circle cx="49.5" cy="48.4" r="0.2"/>
<circle cx="5.1" cy="47.6" r="0.2"/>
<circle cx="14" cy="47.6" r="0.2"/>
<circle cx="14.7" cy="47.6" r="0.2"/>
<circle cx="15.5" cy="47.6" r="0.2"/>
<circle cx="16.2" cy="47.6" r="0.2"/>
<circle cx="17" cy="47.6" r="0.2"/>
<circle cx="17.7" cy="47.6" r="0.2"/>
<circle cx="18.4" cy="47.6" r="0.2"/>
<circle cx="19.2" cy="47.6" r="0.2"/>
<circle cx="19.9" cy="47.6" r="0.2"/>
<circle cx="20.7" cy="47.6" r="0.2"/>
<circle cx="21.4" cy="47.6" r="0.2"/>
<circle cx="22.1" cy="47.6" r="0.2"/>
<circle cx="22.9" cy="47.6" r="0.2"/>
<circle cx="23.6" cy="47.6" r="0.2"/>
<circle cx="24.4" cy="47.6" r="0.2"/>
<circle cx="25.1" cy="47.6" r="0.2"/>
<circle cx="25.8" cy="47.6" r="0.2"/>
<circle cx="27.3" cy="47.6" r="0.2"/>
<circle cx="28.1" cy="47.6" r="0.2"/>
<circle cx="28.8" cy="47.6" r="0.2"/>
<circle cx="29.5" cy="47.6" r="0.2"/>
<circle cx="30.3" cy="47.6" r="0.2"/>
<circle cx="31" cy="47.6" r="0.2"/>
<circle cx="31.7" cy="47.6" r="0.2"/>
<circle cx="32.5" cy="47.6" r="0.2"/>
<circle cx="45.1" cy="47.6" r="0.2"/>
<circle cx="45.8" cy="47.6" r="0.2"/>
<circle cx="46.5" cy="47.6" r="0.2"/>
<circle cx="49.5" cy="47.6" r="0.2"/>
<circle cx="5.9" cy="46.9" r="0.2"/>
<circle cx="6.6" cy="46.9" r="0.2"/>
<circle cx="14" cy="46.9" r="0.2"/>
<circle cx="14.7" cy="46.9" r="0.2"/>
<circle cx="15.5" cy="46.9" r="0.2"/>
<circle cx="16.2" cy="46.9" r="0.2"/>
<circle cx="17" cy="46.9" r="0.2"/>
<circle cx="17.7" cy="46.9" r="0.2"/>
<circle cx="18.4" cy="46.9" r="0.2"/>
<circle cx="19.2" cy="46.9" r="0.2"/>
<circle cx="19.9" cy="46.9" r="0.2"/>
<circle cx="20.7" cy="46.9" r="0.2"/>
<circle cx="21.4" cy="46.9" r="0.2"/>
<circle cx="22.1" cy="46.9" r="0.2"/>
<circle cx="22.9" cy="46.9" r="0.2"/>
<circle cx="23.6" cy="46.9" r="0.2"/>
<circle cx="24.4" cy="46.9" r="0.2"/>
<circle cx="28.1" cy="46.9" r="0.2"/>
<circle cx="28.8" cy="46.9" r="0.2"/>
<circle cx="29.5" cy="46.9" r="0.2"/>
<circle cx="30.3" cy="46.9" r="0.2"/>
<circle cx="31" cy="46.9" r="0.2"/>
<circle cx="31.7" cy="46.9" r="0.2"/>
<circle cx="45.8" cy="46.9" r="0.2"/>
<circle cx="46.5" cy="46.9" r="0.2"/>
<circle cx="49.5" cy="46.9" r="0.2"/>
<circle cx="7.4" cy="46.1" r="0.2"/>
<circle cx="8.1" cy="46.1" r="0.2"/>
<circle cx="12.5" cy="46.1" r="0.2"/>
<circle cx="13.3" cy="46.1" r="0.2"/>
<circle cx="14" cy="46.1" r="0.2"/>
<circle cx="14.7" cy="46.1" r="0.2"/>
<circle cx="15.5" cy="46.1" r="0.2"/>
<circle cx="16.2" cy="46.1" r="0.2"/>
<circle cx="17" cy="46.1" r="0.2"/>
<circle cx="17.7" cy="46.1" r="0.2"/>
<circle cx="18.4" cy="46.1" r="0.2"/>
<circle cx="19.2" cy="46.1" r="0.2"/>
<circle cx="19.9" cy="46.1" r="0.2"/>
<circle cx="20.7" cy="46.1" r="0.2"/>
<circle cx="21.4" cy="46.1" r="0.2"/>
<circle cx="22.1" cy="46.1" r="0.2"/>
<circle cx="22.9" cy="46.1" r="0.2"/>
<circle cx="28.1" cy="46.1" r="0.2"/>
<circle cx="28.8" cy="46.1" r="0.2"/>
<circle cx="29.5" cy="46.1" r="0.2"/>
<circle cx="30.3" cy="46.1" r="0.2"/>
<circle cx="31" cy="46.1" r="0.2"/>
<circle cx="45.8" cy="46.1" r="0.2"/>
<circle cx="46.5" cy="46.1" r="0.2"/>
<circle cx="5.9" cy="45.4" r="0.2"/>
<circle cx="7.4" cy="45.4" r="0.2"/>
<circle cx="12.5" cy="45.4" r="0.2"/>
<circle cx="13.3" cy="45.4" r="0.2"/>
<circle cx="14" cy="45.4" r="0.2"/>
<circle cx="14.7" cy="45.4" r="0.2"/>
<circle cx="15.5" cy="45.4" r="0.2"/>
<circle cx="16.2" cy="45.4" r="0.2"/>
<circle cx="17" cy="45.4" r="0.2"/>
<circle cx="17.7" cy="45.4" r="0.2"/>
<circle cx="18.4" cy="45.4" r="0.2"/>
<circle cx="19.2" cy="45.4" r="0.2"/>
<circle cx="19.9" cy="45.4" r="0.2"/>
<circle cx="20.7" cy="45.4" r="0.2"/>
<circle cx="21.4" cy="45.4" r="0.2"/>
<circle cx="22.1" cy="45.4" r="0.2"/>
<circle cx="22.9" cy="45.4" r="0.2"/>
<circle cx="27.3" cy="45.4" r="0.2"/>
<circle cx="28.1" cy="45.4" r="0.2"/>
<circle cx="28.8" cy="45.4" r="0.2"/>
<circle cx="31" cy="45.4" r="0.2"/>
<circle cx="48.8" cy="45.4" r="0.2"/>
<circle cx="49.5" cy="45.4" r="0.2"/>
<circle cx="5.1" cy="44.7" r="0.2"/>
<circle cx="5.9" cy="44.7" r="0.2"/>
<circle cx="6.6" cy="44.7" r="0.2"/>
<circle cx="7.4" cy="44.7" r="0.2"/>
<circle cx="8.1" cy="44.7" r="0.2"/>
<circle cx="8.8" cy="44.7" r="0.2"/>
<circle cx="10.3" cy="44.7" r="0.2"/>
<circle cx="11" cy="44.7" r="0.2"/>
<circle cx="11.8" cy="44.7" r="0.2"/>
<circle cx="12.5" cy="44.7" r="0.2"/>
<circle cx="13.3" cy="44.7" r="0.2"/>
<circle cx="14" cy="44.7" r="0.2"/>
<circle cx="14.7" cy="44.7" r="0.2"/>
<circle cx="15.5" cy="44.7" r="0.2"/>
<circle cx="16.2" cy="44.7" r="0.2"/>
<circle cx="17" cy="44.7" r="0.2"/>
<circle cx="17.7" cy="44.7" r="0.2"/>
<circle cx="18.4" cy="44.7" r="0.2"/>
<circle cx="19.2" cy="44.7" r="0.2"/>
<circle cx="19.9" cy="44.7" r="0.2"/>
<circle cx="20.7" cy="44.7" r="0.2"/>
<circle cx="21.4" cy="44.7" r="0.2"/>
<circle cx="22.1" cy="44.7" r="0.2"/>
<circle cx="22.9" cy="44.7" r="0.2"/>
<circle cx="28.1" cy="44.7" r="0.2"/>
<circle cx="28.8" cy="44.7" r="0.2"/>
<circle cx="48.8" cy="44.7" r="0.2"/>
<circle cx="49.5" cy="44.7" r="0.2"/>
<circle cx="5.1" cy="43.9" r="0.2"/>
<circle cx="5.9" cy="43.9" r="0.2"/>
<circle cx="6.6" cy="43.9" r="0.2"/>
<circle cx="7.4" cy="43.9" r="0.2"/>
<circle cx="8.1" cy="43.9" r="0.2"/>
<circle cx="8.8" cy="43.9" r="0.2"/>
<circle cx="9.6" cy="43.9" r="0.2"/>
<circle cx="10.3" cy="43.9" r="0.2"/>
<circle cx="11" cy="43.9" r="0.2"/>
<circle cx="11.8" cy="43.9" r="0.2"/>
<circle cx="12.5" cy="43.9" r="0.2"/>
<circle cx="13.3" cy="43.9" r="0.2"/>
<circle cx="14" cy="43.9" r="0.2"/>
<circle cx="14.7" cy="43.9" r="0.2"/>
<circle cx="15.5" cy="43.9" r="0.2"/>
<circle cx="16.2" cy="43.9" r="0.2"/>
<circle cx="17" cy="43.9" r="0.2"/>
<circle cx="17.7" cy="43.9" r="0.2"/>
<circle cx="18.4" cy="43.9" r="0.2"/>
<circle cx="19.2" cy="43.9" r="0.2"/>
<circle cx="19.9" cy="43.9" r="0.2"/>
<circle cx="20.7" cy="43.9" r="0.2"/>
<circle cx="21.4" cy="43.9" r="0.2"/>
<circle cx="22.1" cy="43.9" r="0.2"/>
<circle cx="22.9" cy="43.9" r="0.2"/>
<circle cx="27.3" cy="43.9" r="0.2"/>
<circle cx="28.1" cy="43.9" r="0.2"/>
<circle cx="30.3" cy="43.9" r="0.2"/>
<circle cx="48.8" cy="43.9" r="0.2"/>
<circle cx="49.5" cy="43.9" r="0.2"/>
<circle cx="5.9" cy="43.2" r="0.2"/>
<circle cx="6.6" cy="43.2" r="0.2"/>
<circle cx="7.4" cy="43.2" r="0.2"/>
<circle cx="8.1" cy="43.2" r="0.2"/>
<circle cx="8.8" cy="43.2" r="0.2"/>
<circle cx="9.6" cy="43.2" r="0.2"/>
<circle cx="10.3" cy="43.2" r="0.2"/>
<circle cx="11" cy="43.2" r="0.2"/>
<circle cx="11.8" cy="43.2" r="0.2"/>
<circle cx="12.5" cy="43.2" r="0.2"/>
<circle cx="13.3" cy="43.2" r="0.2"/>
<circle cx="14" cy="43.2" r="0.2"/>
<circle cx="14.7" cy="43.2" r="0.2"/>
<circle cx="15.5" cy="43.2" r="0.2"/>
<circle cx="16.2" cy="43.2" r="0.2"/>
<circle cx="17" cy="43.2" r="0.2"/>
<circle cx="17.7" cy="43.2" r="0.2"/>
<circle cx="18.4" cy="43.2" r="0.2"/>
<circle cx="19.2" cy="43.2" r="0.2"/>
<circle cx="19.9" cy="43.2" r="0.2"/>
<circle cx="20.7" cy="43.2" r="0.2"/>
<circle cx="21.4" cy="43.2" r="0.2"/>
<circle cx="22.1" cy="43.2" r="0.2"/>
<circle cx="22.9" cy="43.2" r="0.2"/>
<circle cx="23.6" cy="43.2" r="0.2"/>
<circle cx="26.6" cy="43.2" r="0.2"/>
<circle cx="29.5" cy="43.2" r="0.2"/>
<circle cx="30.3" cy="43.2" r="0.2"/>
<circle cx="49.5" cy="43.2" r="0.2"/>
<circle cx="6.6" cy="42.4" r="0.2"/>
<circle cx="7.4" cy="42.4" r="0.2"/>
<circle cx="8.1" cy="42.4" r="0.2"/>
<circle cx="8.8" cy="42.4" r="0.2"/>
<circle cx="9.6" cy="42.4" r="0.2"/>
<circle cx="10.3" cy="42.4" r="0.2"/>
<circle cx="11" cy="42.4" r="0.2"/>
<circle cx="11.8" cy="42.4" r="0.2"/>
<circle cx="12.5" cy="42.4" r="0.2"/>
<circle cx="13.3" cy="42.4" r="0.2"/>
<circle cx="14" cy="42.4" r="0.2"/>
<circle cx="14.7" cy="42.4" r="0.2"/>
<circle cx="15.5" cy="42.4" r="0.2"/>
<circle cx="16.2" cy="42.4" r="0.2"/>
<circle cx="17" cy="42.4" r="0.2"/>
<circle cx="17.7" cy="42.4" r="0.2"/>
<circle cx="18.4" cy="42.4" r="0.2"/>
<circle cx="19.2" cy="42.4" r="0.2"/>
<circle cx="19.9" cy="42.4" r="0.2"/>
<circle cx="20.7" cy="42.4" r="0.2"/>
<circle cx="21.4" cy="42.4" r="0.2"/>
<circle cx="22.1" cy="42.4" r="0.2"/>
<circle cx="22.9" cy="42.4" r="0.2"/>
<circle cx="23.6" cy="42.4" r="0.2"/>
<circle cx="24.4" cy="42.4" r="0.2"/>
<circle cx="25.1" cy="42.4" r="0.2"/>
<circle cx="25.8" cy="42.4" r="0.2"/>
<circle cx="27.3" cy="42.4" r="0.2"/>
<circle cx="28.1" cy="42.4" r="0.2"/>
<circle cx="28.8" cy="42.4" r="0.2"/>
<circle cx="29.5" cy="42.4" r="0.2"/>
<circle cx="30.3" cy="42.4" r="0.2"/>
<circle cx="4.4" cy="41.7" r="0.2"/>
<circle cx="5.1" cy="41.7" r="0.2"/>
<circle cx="5.9" cy="41.7" r="0.2"/>
<circle cx="6.6" cy="41.7" r="0.2"/>
<circle cx="7.4" cy="41.7" r="0.2"/>
<circle cx="8.1" cy="41.7" r="0.2"/>
<circle cx="8.8" cy="41.7" r="0.2"/>
<circle cx="9.6" cy="41.7" r="0.2"/>
<circle cx="10.3" cy="41.7" r="0.2"/>
<circle cx="11" cy="41.7" r="0.2"/>
<circle cx="11.8" cy="41.7" r="0.2"/>
<circle cx="12.5" cy="41.7" r="0.2"/>
<circle cx="13.3" cy="41.7" r="0.2"/>
<circle cx="14" cy="41.7" r="0.2"/>
<circle cx="14.7" cy="41.7" r="0.2"/>
<circle cx="15.5" cy="41.7" r="0.2"/>
<circle cx="16.2" cy="41.7" r="0.2"/>
<circle cx="17" cy="41.7" r="0.2"/>
<circle cx="17.7" cy="41.7" r="0.2"/>
<circle cx="18.4" cy="41.7" r="0.2"/>
<circle cx="19.2" cy="41.7" r="0.2"/>
<circle cx="19.9" cy="41.7" r="0.2"/>
<circle cx="20.7" cy="41.7" r="0.2"/>
<circle cx="21.4" cy="41.7" r="0.2"/>
<circle cx="22.1" cy="41.7" r="0.2"/>
<circle cx="22.9" cy="41.7" r="0.2"/>
<circle cx="23.6" cy="41.7" r="0.2"/>
<circle cx="24.4" cy="41.7" r="0.2"/>
<circle cx="25.1" cy="41.7" r="0.2"/>
<circle cx="28.1" cy="41.7" r="0.2"/>
<circle cx="28.8" cy="41.7" r="0.2"/>
<circle cx="29.5" cy="41.7" r="0.2"/>
<circle cx="31" cy="41.7" r="0.2"/>
<circle cx="5.9" cy="41" r="0.2"/>
<circle cx="6.6" cy="41" r="0.2"/>
<circle cx="7.4" cy="41" r="0.2"/>
<circle cx="8.1" cy="41" r="0.2"/>
<circle cx="8.8" cy="41" r="0.2"/>
<circle cx="9.6" cy="41" r="0.2"/>
<circle cx="10.3" cy="41" r="0.2"/>
<circle cx="11" cy="41" r="0.2"/>
<circle cx="11.8" cy="41" r="0.2"/>
<circle cx="12.5" cy="41" r="0.2"/>
<circle cx="13.3" cy="41" r="0.2"/>
<circle cx="14" cy="41" r="0.2"/>
<circle cx="14.7" cy="41" r="0.2"/>
<circle cx="15.5" cy="41" r="0.2"/>
<circle cx="16.2" cy="41" r="0.2"/>
<circle cx="17" cy="41" r="0.2"/>
<circle cx="17.7" cy="41" r="0.2"/>
<circle cx="18.4" cy="41" r="0.2"/>
<circle cx="19.2" cy="41" r="0.2"/>
<circle cx="19.9" cy="41" r="0.2"/>
<circle cx="20.7" cy="41" r="0.2"/>
<circle cx="21.4" cy="41" r="0.2"/>
<circle cx="22.1" cy="41" r="0.2"/>
<circle cx="22.9" cy="41" r="0.2"/>
<circle cx="23.6" cy="41" r="0.2"/>
<circle cx="24.4" cy="41" r="0.2"/>
<circle cx="25.1" cy="41" r="0.2"/>
<circle cx="25.8" cy="41" r="0.2"/>
<circle cx="28.8" cy="41" r="0.2"/>
<circle cx="29.5" cy="41" r="0.2"/>
<circle cx="30.3" cy="41" r="0.2"/>
<circle cx="31" cy="41" r="0.2"/>
<circle cx="5.1" cy="40.2" r="0.2"/>
<circle cx="5.9" cy="40.2" r="0.2"/>
<circle cx="6.6" cy="40.2" r="0.2"/>
<circle cx="7.4" cy="40.2" r="0.2"/>
<circle cx="8.1" cy="40.2" r="0.2"/>
<circle cx="8.8" cy="40.2" r="0.2"/>
<circle cx="9.6" cy="40.2" r="0.2"/>
<circle cx="10.3" cy="40.2" r="0.2"/>
<circle cx="11" cy="40.2" r="0.2"/>
<circle cx="11.8" cy="40.2" r="0.2"/>
<circle cx="12.5" cy="40.2" r="0.2"/>
<circle cx="13.3" cy="40.2" r="0.2"/>
<circle cx="14" cy="40.2" r="0.2"/>
<circle cx="14.7" cy="40.2" r="0.2"/>
<circle cx="15.5" cy="40.2" r="0.2"/>
<circle cx="16.2" cy="40.2" r="0.2"/>
<circle cx="17" cy="40.2" r="0.2"/>
<circle cx="19.9" cy="40.2" r="0.2"/>
<circle cx="20.7" cy="40.2" r="0.2"/>
<circle cx="22.1" cy="40.2" r="0.2"/>
<circle cx="22.9" cy="40.2" r="0.2"/>
<circle cx="23.6" cy="40.2" r="0.2"/>
<circle cx="24.4" cy="40.2" r="0.2"/>
<circle cx="25.1" cy="40.2" r="0.2"/>
<circle cx="25.8" cy="40.2" r="0.2"/>
<circle cx="27.3" cy="40.2" r="0.2"/>
<circle cx="28.8" cy="40.2" r="0.2"/>
<circle cx="29.5" cy="40.2" r="0.2"/>
<circle cx="30.3" cy="40.2" r="0.2"/>
<circle cx="5.9" cy="39.5" r="0.2"/>
<circle cx="6.6" cy="39.5" r="0.2"/>
<circle cx="7.4" cy="39.5" r="0.2"/>
<circle cx="8.1" cy="39.5" r="0.2"/>
<circle cx="8.8" cy="39.5" r="0.2"/>
<circle cx="9.6" cy="39.5" r="0.2"/>
<circle cx="10.3" cy="39.5" r="0.2"/>
<circle cx="11" cy="39.5" r="0.2"/>
<circle cx="11.8" cy="39.5" r="0.2"/>
<circle cx="14" cy="39.5" r="0.2"/>
<circle cx="14.7" cy="39.5" r="0.2"/>
<circle cx="15.5" cy="39.5" r="0.2"/>
<circle cx="16.2" cy="39.5" r="0.2"/>
<circle cx="18.4" cy="39.5" r="0.2"/>
<circle cx="19.2" cy="39.5" r="0.2"/>
<circle cx="20.7" cy="39.5" r="0.2"/>
<circle cx="22.1" cy="39.5" r="0.2"/>
<circle cx="22.9" cy="39.5" r="0.2"/>
<circle cx="23.6" cy="39.5" r="0.2"/>
<circle cx="24.4" cy="39.5" r="0.2"/>
<circle cx="25.8" cy="39.5" r="0.2"/>
<circle cx="28.1" cy="39.5" r="0.2"/>
<circle cx="28.8" cy="39.5" r="0.2"/>
<circle cx="29.5" cy="39.5" r="0.2"/>
<circle cx="5.9" cy="38.7" r="0.2"/>
<circle cx="6.6" cy="38.7" r="0.2"/>
<circle cx="7.4" cy="38.7" r="0.2"/>
<circle cx="8.1" cy="38.7" r="0.2"/>
<circle cx="8.8" cy="38.7" r="0.2"/>
<circle cx="9.6" cy="38.7" r="0.2"/>
<circle cx="10.3" cy="38.7" r="0.2"/>
<circle cx="17.7" cy="38.7" r="0.2"/>
<circle cx="18.4" cy="38.7" r="0.2"/>
<circle cx="19.2" cy="38.7" r="0.2"/>
<circle cx="19.9" cy="38.7" r="0.2"/>
<circle cx="20.7" cy="38.7" r="0.2"/>
<circle cx="21.4" cy="38.7" r="0.2"/>
<circle cx="22.9" cy="38.7" r="0.2"/>
<circle cx="23.6" cy="38.7" r="0.2"/>
<circle cx="25.8" cy="38.7" r="0.2"/>
<circle cx="26.6" cy="38.7" r="0.2"/>
<circle cx="27.3" cy="38.7" r="0.2"/>
<circle cx="28.1" cy="38.7" r="0.2"/>
<circle cx="28.8" cy="38.7" r="0.2"/>
<circle cx="29.5" cy="38.7" r="0.2"/>
<circle cx="7.4" cy="38" r="0.2"/>
<circle cx="8.1" cy="38" r="0.2"/>
<circle cx="17" cy="38" r="0.2"/>
<circle cx="17.7" cy="38" r="0.2"/>
<circle cx="18.4" cy="38" r="0.2"/>
<circle cx="19.2" cy="38" r="0.2"/>
<circle cx="19.9" cy="38" r="0.2"/>
<circle cx="22.9" cy="38" r="0.2"/>
<circle cx="25.1" cy="38" r="0.2"/>
<circle cx="25.8" cy="38" r="0.2"/>
<circle cx="26.6" cy="38" r="0.2"/>
<circle cx="27.3" cy="38" r="0.2"/>
<circle cx="28.1" cy="38" r="0.2"/>
<circle cx="28.8" cy="38" r="0.2"/>
<circle cx="15.5" cy="37.3" r="0.2"/>
<circle cx="16.2" cy="37.3" r="0.2"/>
<circle cx="17" cy="37.3" r="0.2"/>
<circle cx="17.7" cy="37.3" r="0.2"/>
<circle cx="18.4" cy="37.3" r="0.2"/>
<circle cx="19.2" cy="37.3" r="0.2"/>
<circle cx="19.9" cy="37.3" r="0.2"/>
<circle cx="22.1" cy="37.3" r="0.2"/>
<circle cx="22.9" cy="37.3" r="0.2"/>
<circle cx="24.4" cy="37.3" r="0.2"/>
<circle cx="25.1" cy="37.3" r="0.2"/>
<circle cx="25.8" cy="37.3" r="0.2"/>
<circle cx="26.6" cy="37.3" r="0.2"/>
<circle cx="27.3" cy="37.3" r="0.2"/>
<circle cx="28.1" cy="37.3" r="0.2"/>
<circle cx="15.5" cy="36.5" r="0.2"/>
<circle cx="16.2" cy="36.5" r="0.2"/>
<circle cx="17.7" cy="36.5" r="0.2"/>
<circle cx="18.4" cy="36.5" r="0.2"/>
<circle cx="19.2" cy="36.5" r="0.2"/>
<circle cx="19.9" cy="36.5" r="0.2"/>
<circle cx="21.4" cy="36.5" r="0.2"/>
<circle cx="22.1" cy="36.5" r="0.2"/>
<circle cx="22.9" cy="36.5" r="0.2"/>
<circle cx="23.6" cy="36.5" r="0.2"/>
<circle cx="24.4" cy="36.5" r="0.2"/>
<circle cx="25.8" cy="36.5" r="0.2"/>
<circle cx="26.6" cy="36.5" r="0.2"/>
<circle cx="27.3" cy="36.5" r="0.2"/>
<circle cx="15.5" cy="35.8" r="0.2"/>
<circle cx="16.2" cy="35.8" r="0.2"/>
<circle cx="17" cy="35.8" r="0.2"/>
<circle cx="22.1" cy="35.8" r="0.2"/>
<circle cx="22.9" cy="35.8" r="0.2"/>
<circle cx="23.6" cy="35.8" r="0.2"/>
<circle cx="25.1" cy="35.8" r="0.2"/>
<circle cx="25.8" cy="35.8" r="0.2"/>
<circle cx="15.5" cy="35" r="0.2"/>
<circle cx="84.9" cy="76.4" r="0.2"/>
<circle cx="84.2" cy="75.6" r="0.2"/>
<circle cx="84.9" cy="75.6" r="0.2"/>
<circle cx="83.4" cy="74.9" r="0.2"/>
<circle cx="83.4" cy="74.2" r="0.2"/>
<circle cx="84.2" cy="74.2" r="0.2"/>
<circle cx="84.9" cy="74.2" r="0.2"/>
<circle cx="85.6" cy="74.2" r="0.2"/>
<circle cx="52.4" cy="73.4" r="0.2"/>
<circle cx="53.8" cy="73.4" r="0.2"/>
<circle cx="76.8" cy="73.4" r="0.2"/>
<circle cx="77.5" cy="73.4" r="0.2"/>
<circle cx="79" cy="73.4" r="0.2"/>
<circle cx="81.9" cy="73.4" r="0.2"/>
<circle cx="82.7" cy="73.4" r="0.2"/>
<circle cx="83.4" cy="73.4" r="0.2"/>
<circle cx="84.2" cy="73.4" r="0.2"/>
<circle cx="84.9" cy="73.4" r="0.2"/>
<circle cx="85.6" cy="73.4" r="0.2"/>
<circle cx="52.4" cy="72.7" r="0.2"/>
<circle cx="53.1" cy="72.7" r="0.2"/>
<circle cx="53.8" cy="72.7" r="0.2"/>
<circle cx="54.6" cy="72.7" r="0.2"/>
<circle cx="77.5" cy="72.7" r="0.2"/>
<circle cx="78.2" cy="72.7" r="0.2"/>
<circle cx="79" cy="72.7" r="0.2"/>
<circle cx="79.7" cy="72.7" r="0.2"/>
<circle cx="81.2" cy="72.7" r="0.2"/>
<circle cx="81.9" cy="72.7" r="0.2"/>
<circle cx="82.7" cy="72.7" r="0.2"/>
<circle cx="83.4" cy="72.7" r="0.2"/>
<circle cx="84.2" cy="72.7" r="0.2"/>
<circle cx="84.9" cy="72.7" r="0.2"/>
<circle cx="85.6" cy="72.7" r="0.2"/>
<circle cx="86.4" cy="72.7" r="0.2"/>
<circle cx="52.4" cy="71.9" r="0.2"/>
<circle cx="53.1" cy="71.9" r="0.2"/>
<circle cx="53.8" cy="71.9" r="0.2"/>
<circle cx="54.6" cy="71.9" r="0.2"/>
<circle cx="55.3" cy="71.9" r="0.2"/>
<circle cx="76.8" cy="71.9" r="0.2"/>
<circle cx="77.5" cy="71.9" r="0.2"/>
<circle cx="78.2" cy="71.9" r="0.2"/>
<circle cx="79" cy="71.9" r="0.2"/>
<circle cx="79.7" cy="71.9" r="0.2"/>
<circle cx="80.5" cy="71.9" r="0.2"/>
<circle cx="81.2" cy="71.9" r="0.2"/>
<circle cx="81.9" cy="71.9" r="0.2"/>
<circle cx="82.7" cy="71.9" r="0.2"/>
<circle cx="83.4" cy="71.9" r="0.2"/>
<circle cx="84.2" cy="71.9" r="0.2"/>
<circle cx="84.9" cy="71.9" r="0.2"/>
<circle cx="85.6" cy="71.9" r="0.2"/>
<circle cx="51.6" cy="71.2" r="0.2"/>
<circle cx="52.4" cy="71.2" r="0.2"/>
<circle cx="53.1" cy="71.2" r="0.2"/>
<circle cx="53.8" cy="71.2" r="0.2"/>
<circle cx="54.6" cy="71.2" r="0.2"/>
<circle cx="55.3" cy="71.2" r="0.2"/>
<circle cx="76" cy="71.2" r="0.2"/>
<circle cx="76.8" cy="71.2" r="0.2"/>
<circle cx="77.5" cy="71.2" r="0.2"/>
<circle cx="78.2" cy="71.2" r="0.2"/>
<circle cx="79" cy="71.2" r="0.2"/>
<circle cx="79.7" cy="71.2" r="0.2"/>
<circle cx="80.5" cy="71.2" r="0.2"/>
<circle cx="81.2" cy="71.2" r="0.2"/>
<circle cx="81.9" cy="71.2" r="0.2"/>
<circle cx="82.7" cy="71.2" r="0.2"/>
<circle cx="83.4" cy="71.2" r="0.2"/>
<circle cx="84.2" cy="71.2" r="0.2"/>
<circle cx="84.9" cy="71.2" r="0.2"/>
<circle cx="85.6" cy="71.2" r="0.2"/>
<circle cx="51.6" cy="70.5" r="0.2"/>
<circle cx="52.4" cy="70.5" r="0.2"/>
<circle cx="53.1" cy="70.5" r="0.2"/>
<circle cx="53.8" cy="70.5" r="0.2"/>
<circle cx="54.6" cy="70.5" r="0.2"/>
<circle cx="55.3" cy="70.5" r="0.2"/>
<circle cx="56.1" cy="70.5" r="0.2"/>
<circle cx="59" cy="70.5" r="0.2"/>
<circle cx="76.8" cy="70.5" r="0.2"/>
<circle cx="77.5" cy="70.5" r="0.2"/>
<circle cx="78.2" cy="70.5" r="0.2"/>
<circle cx="79" cy="70.5" r="0.2"/>
<circle cx="79.7" cy="70.5" r="0.2"/>
<circle cx="80.5" cy="70.5" r="0.2"/>
<circle cx="81.2" cy="70.5" r="0.2"/>
<circle cx="81.9" cy="70.5" r="0.2"/>
<circle cx="82.7" cy="70.5" r="0.2"/>
<circle cx="83.4" cy="70.5" r="0.2"/>
<circle cx="84.2" cy="70.5" r="0.2"/>
<circle cx="84.9" cy="70.5" r="0.2"/>
<circle cx="85.6" cy="70.5" r="0.2"/>
<circle cx="50.9" cy="69.7" r="0.2"/>
<circle cx="51.6" cy="69.7" r="0.2"/>
<circle cx="52.4" cy="69.7" r="0.2"/>
<circle cx="53.1" cy="69.7" r="0.2"/>
<circle cx="53.8" cy="69.7" r="0.2"/>
<circle cx="54.6" cy="69.7" r="0.2"/>
<circle cx="55.3" cy="69.7" r="0.2"/>
<circle cx="56.1" cy="69.7" r="0.2"/>
<circle cx="59" cy="69.7" r="0.2"/>
<circle cx="76.8" cy="69.7" r="0.2"/>
<circle cx="77.5" cy="69.7" r="0.2"/>
<circle cx="78.2" cy="69.7" r="0.2"/>
<circle cx="79" cy="69.7" r="0.2"/>
<circle cx="79.7" cy="69.7" r="0.2"/>
<circle cx="80.5" cy="69.7" r="0.2"/>
<circle cx="81.2" cy="69.7" r="0.2"/>
<circle cx="81.9" cy="69.7" r="0.2"/>
<circle cx="82.7" cy="69.7" r="0.2"/>
<circle cx="83.4" cy="69.7" r="0.2"/>
<circle cx="84.2" cy="69.7" r="0.2"/>
<circle cx="84.9" cy="69.7" r="0.2"/>
<circle cx="50.9" cy="69" r="0.2"/>
<circle cx="51.6" cy="69" r="0.2"/>
<circle cx="52.4" cy="69" r="0.2"/>
<circle cx="53.1" cy="69" r="0.2"/>
<circle cx="53.8" cy="69" r="0.2"/>
<circle cx="54.6" cy="69" r="0.2"/>
<circle cx="55.3" cy="69" r="0.2"/>
<circle cx="56.1" cy="69" r="0.2"/>
<circle cx="59" cy="69" r="0.2"/>
<circle cx="59.8" cy="69" r="0.2"/>
<circle cx="78.2" cy="69" r="0.2"/>
<circle cx="79" cy="69" r="0.2"/>
<circle cx="79.7" cy="69" r="0.2"/>
<circle cx="80.5" cy="69" r="0.2"/>
<circle cx="81.2" cy="69" r="0.2"/>
<circle cx="81.9" cy="69" r="0.2"/>
<circle cx="82.7" cy="69" r="0.2"/>
<circle cx="83.4" cy="69" r="0.2"/>
<circle cx="84.2" cy="69" r="0.2"/>
<circle cx="50.1" cy="68.2" r="0.2"/>
<circle cx="50.9" cy="68.2" r="0.2"/>
<circle cx="51.6" cy="68.2" r="0.2"/>
<circle cx="52.4" cy="68.2" r="0.2"/>
<circle cx="53.1" cy="68.2" r="0.2"/>
<circle cx="53.8" cy="68.2" r="0.2"/>
<circle cx="54.6" cy="68.2" r="0.2"/>
<circle cx="55.3" cy="68.2" r="0.2"/>
<circle cx="56.1" cy="68.2" r="0.2"/>
<circle cx="56.8" cy="68.2" r="0.2"/>
<circle cx="57.5" cy="68.2" r="0.2"/>
<circle cx="59.8" cy="68.2" r="0.2"/>
<circle cx="79" cy="68.2" r="0.2"/>
<circle cx="79.7" cy="68.2" r="0.2"/>
<circle cx="80.5" cy="68.2" r="0.2"/>
<circle cx="81.2" cy="68.2" r="0.2"/>
<circle cx="81.9" cy="68.2" r="0.2"/>
<circle cx="83.4" cy="68.2" r="0.2"/>
<circle cx="84.2" cy="68.2" r="0.2"/>
<circle cx="50.9" cy="67.5" r="0.2"/>
<circle cx="51.6" cy="67.5" r="0.2"/>
<circle cx="52.4" cy="67.5" r="0.2"/>
<circle cx="53.1" cy="67.5" r="0.2"/>
<circle cx="53.8" cy="67.5" r="0.2"/>
<circle cx="54.6" cy="67.5" r="0.2"/>
<circle cx="55.3" cy="67.5" r="0.2"/>
<circle cx="56.1" cy="67.5" r="0.2"/>
<circle cx="56.8" cy="67.5" r="0.2"/>
<circle cx="57.5" cy="67.5" r="0.2"/>
<circle cx="59.8" cy="67.5" r="0.2"/>
<circle cx="80.5" cy="67.5" r="0.2"/>
<circle cx="81.2" cy="67.5" r="0.2"/>
<circle cx="81.9" cy="67.5" r="0.2"/>
<circle cx="83.4" cy="67.5" r="0.2"/>
<circle cx="50.9" cy="66.8" r="0.2"/>
<circle cx="51.6" cy="66.8" r="0.2"/>
<circle cx="52.4" cy="66.8" r="0.2"/>
<circle cx="53.1" cy="66.8" r="0.2"/>
<circle cx="53.8" cy="66.8" r="0.2"/>
<circle cx="54.6" cy="66.8" r="0.2"/>
<circle cx="55.3" cy="66.8" r="0.2"/>
<circle cx="56.1" cy="66.8" r="0.2"/>
<circle cx="56.8" cy="66.8" r="0.2"/>
<circle cx="57.5" cy="66.8" r="0.2"/>
<circle cx="78.2" cy="66.8" r="0.2"/>
<circle cx="79" cy="66.8" r="0.2"/>
<circle cx="84.9" cy="66.8" r="0.2"/>
<circle cx="85.6" cy="66.8" r="0.2"/>
<circle cx="50.9" cy="66" r="0.2"/>
<circle cx="51.6" cy="66" r="0.2"/>
<circle cx="52.4" cy="66" r="0.2"/>
<circle cx="53.1" cy="66" r="0.2"/>
<circle cx="53.8" cy="66" r="0.2"/>
<circle cx="54.6" cy="66" r="0.2"/>
<circle cx="55.3" cy="66" r="0.2"/>
<circle cx="56.1" cy="66" r="0.2"/>
<circle cx="56.8" cy="66" r="0.2"/>
<circle cx="74.5" cy="66" r="0.2"/>
<circle cx="75.3" cy="66" r="0.2"/>
<circle cx="76" cy="66" r="0.2"/>
<circle cx="82.7" cy="66" r="0.2"/>
<circle cx="83.4" cy="66" r="0.2"/>
<circle cx="84.2" cy="66" r="0.2"/>
<circle cx="50.2" cy="65.3" r="0.2"/>
<circle cx="50.9" cy="65.3" r="0.2"/>
<circle cx="51.6" cy="65.3" r="0.2"/>
<circle cx="52.4" cy="65.3" r="0.2"/>
<circle cx="53.1" cy="65.3" r="0.2"/>
<circle cx="53.8" cy="65.3" r="0.2"/>
<circle cx="54.6" cy="65.3" r="0.2"/>
<circle cx="55.3" cy="65.3" r="0.2"/>
<circle cx="56.1" cy="65.3" r="0.2"/>
<circle cx="56.8" cy="65.3" r="0.2"/>
<circle cx="73.8" cy="65.3" r="0.2"/>
<circle cx="78.2" cy="65.3" r="0.2"/>
<circle cx="81.2" cy="65.3" r="0.2"/>
<circle cx="81.9" cy="65.3" r="0.2"/>
<circle cx="82.7" cy="65.3" r="0.2"/>
<circle cx="83.4" cy="65.3" r="0.2"/>
<circle cx="84.2" cy="65.3" r="0.2"/>
<circle cx="85.6" cy="65.3" r="0.2"/>
<circle cx="50.2" cy="64.5" r="0.2"/>
<circle cx="50.9" cy="64.5" r="0.2"/>
<circle cx="51.6" cy="64.5" r="0.2"/>
<circle cx="52.4" cy="64.5" r="0.2"/>
<circle cx="53.1" cy="64.5" r="0.2"/>
<circle cx="53.8" cy="64.5" r="0.2"/>
<circle cx="54.6" cy="64.5" r="0.2"/>
<circle cx="55.3" cy="64.5" r="0.2"/>
<circle cx="56.1" cy="64.5" r="0.2"/>
<circle cx="56.8" cy="64.5" r="0.2"/>
<circle cx="57.5" cy="64.5" r="0.2"/>
<circle cx="73.1" cy="64.5" r="0.2"/>
<circle cx="73.8" cy="64.5" r="0.2"/>
<circle cx="75.3" cy="64.5" r="0.2"/>
<circle cx="76" cy="64.5" r="0.2"/>
<circle cx="76.8" cy="64.5" r="0.2"/>
<circle cx="78.2" cy="64.5" r="0.2"/>
<circle cx="81.2" cy="64.5" r="0.2"/>
<circle cx="50.2" cy="63.8" r="0.2"/>
<circle cx="50.9" cy="63.8" r="0.2"/>
<circle cx="51.6" cy="63.8" r="0.2"/>
<circle cx="52.4" cy="63.8" r="0.2"/>
<circle cx="53.1" cy="63.8" r="0.2"/>
<circle cx="53.8" cy="63.8" r="0.2"/>
<circle cx="54.6" cy="63.8" r="0.2"/>
<circle cx="55.3" cy="63.8" r="0.2"/>
<circle cx="56.1" cy="63.8" r="0.2"/>
<circle cx="56.8" cy="63.8" r="0.2"/>
<circle cx="57.5" cy="63.8" r="0.2"/>
<circle cx="58.3" cy="63.8" r="0.2"/>
<circle cx="73.1" cy="63.8" r="0.2"/>
<circle cx="73.8" cy="63.8" r="0.2"/>
<circle cx="75.3" cy="63.8" r="0.2"/>
<circle cx="76" cy="63.8" r="0.2"/>
<circle cx="76.8" cy="63.8" r="0.2"/>
<circle cx="78.2" cy="63.8" r="0.2"/>
<circle cx="79" cy="63.8" r="0.2"/>
<circle cx="50.2" cy="63.1" r="0.2"/>
<circle cx="50.9" cy="63.1" r="0.2"/>
<circle cx="51.6" cy="63.1" r="0.2"/>
<circle cx="52.4" cy="63.1" r="0.2"/>
<circle cx="53.1" cy="63.1" r="0.2"/>
<circle cx="53.8" cy="63.1" r="0.2"/>
<circle cx="54.6" cy="63.1" r="0.2"/>
<circle cx="55.3" cy="63.1" r="0.2"/>
<circle cx="56.1" cy="63.1" r="0.2"/>
<circle cx="56.8" cy="63.1" r="0.2"/>
<circle cx="57.5" cy="63.1" r="0.2"/>
<circle cx="58.3" cy="63.1" r="0.2"/>
<circle cx="59" cy="63.1" r="0.2"/>
<circle cx="71.6" cy="63.1" r="0.2"/>
<circle cx="72.3" cy="63.1" r="0.2"/>
<circle cx="73.1" cy="63.1" r="0.2"/>
<circle cx="76.8" cy="63.1" r="0.2"/>
<circle cx="50.2" cy="62.3" r="0.2"/>
<circle cx="50.9" cy="62.3" r="0.2"/>
<circle cx="51.6" cy="62.3" r="0.2"/>
<circle cx="52.4" cy="62.3" r="0.2"/>
<circle cx="53.1" cy="62.3" r="0.2"/>
<circle cx="53.8" cy="62.3" r="0.2"/>
<circle cx="54.6" cy="62.3" r="0.2"/>
<circle cx="55.3" cy="62.3" r="0.2"/>
<circle cx="56.1" cy="62.3" r="0.2"/>
<circle cx="56.8" cy="62.3" r="0.2"/>
<circle cx="57.5" cy="62.3" r="0.2"/>
<circle cx="58.3" cy="62.3" r="0.2"/>
<circle cx="59" cy="62.3" r="0.2"/>
<circle cx="59.8" cy="62.3" r="0.2"/>
<circle cx="67.9" cy="62.3" r="0.2"/>
<circle cx="73.1" cy="62.3" r="0.2"/>
<circle cx="78.3" cy="62.3" r="0.2"/>
<circle cx="79" cy="62.3" r="0.2"/>
<circle cx="50.2" cy="61.6" r="0.2"/>
<circle cx="50.9" cy="61.6" r="0.2"/>
<circle cx="51.6" cy="61.6" r="0.2"/>
<circle cx="52.4" cy="61.6" r="0.2"/>
<circle cx="53.1" cy="61.6" r="0.2"/>
<circle cx="53.8" cy="61.6" r="0.2"/>
<circle cx="54.6" cy="61.6" r="0.2"/>
<circle cx="55.3" cy="61.6" r="0.2"/>
<circle cx="56.1" cy="61.6" r="0.2"/>
<circle cx="56.8" cy="61.6" r="0.2"/>
<circle cx="57.5" cy="61.6" r="0.2"/>
<circle cx="58.3" cy="61.6" r="0.2"/>
<circle cx="59" cy="61.6" r="0.2"/>
<circle cx="59.8" cy="61.6" r="0.2"/>
<circle cx="67.2" cy="61.6" r="0.2"/>
<circle cx="72.3" cy="61.6" r="0.2"/>
<circle cx="74.5" cy="61.6" r="0.2"/>
<circle cx="77.5" cy="61.6" r="0.2"/>
<circle cx="79" cy="61.6" r="0.2"/>
<circle cx="50.2" cy="60.8" r="0.2"/>
<circle cx="50.9" cy="60.8" r="0.2"/>
<circle cx="51.6" cy="60.8" r="0.2"/>
<circle cx="52.4" cy="60.8" r="0.2"/>
<circle cx="53.1" cy="60.8" r="0.2"/>
<circle cx="53.8" cy="60.8" r="0.2"/>
<circle cx="54.6" cy="60.8" r="0.2"/>
<circle cx="55.3" cy="60.8" r="0.2"/>
<circle cx="56.1" cy="60.8" r="0.2"/>
<circle cx="56.8" cy="60.8" r="0.2"/>
<circle cx="57.5" cy="60.8" r="0.2"/>
<circle cx="66.4" cy="60.8" r="0.2"/>
<circle cx="67.2" cy="60.8" r="0.2"/>
<circle cx="72.3" cy="60.8" r="0.2"/>
<circle cx="73.1" cy="60.8" r="0.2"/>
<circle cx="73.8" cy="60.8" r="0.2"/>
<circle cx="74.5" cy="60.8" r="0.2"/>
<circle cx="78.3" cy="60.8" r="0.2"/>
<circle cx="79" cy="60.8" r="0.2"/>
<circle cx="50.2" cy="60.1" r="0.2"/>
<circle cx="50.9" cy="60.1" r="0.2"/>
<circle cx="51.6" cy="60.1" r="0.2"/>
<circle cx="52.4" cy="60.1" r="0.2"/>
<circle cx="53.1" cy="60.1" r="0.2"/>
<circle cx="53.8" cy="60.1" r="0.2"/>
<circle cx="54.6" cy="60.1" r="0.2"/>
<circle cx="55.3" cy="60.1" r="0.2"/>
<circle cx="56.1" cy="60.1" r="0.2"/>
<circle cx="56.8" cy="60.1" r="0.2"/>
<circle cx="58.3" cy="60.1" r="0.2"/>
<circle cx="59" cy="60.1" r="0.2"/>
<circle cx="59.8" cy="60.1" r="0.2"/>
<circle cx="60.5" cy="60.1" r="0.2"/>
<circle cx="66.4" cy="60.1" r="0.2"/>
<circle cx="67.2" cy="60.1" r="0.2"/>
<circle cx="71.6" cy="60.1" r="0.2"/>
<circle cx="72.3" cy="60.1" r="0.2"/>
<circle cx="73.1" cy="60.1" r="0.2"/>
<circle cx="73.8" cy="60.1" r="0.2"/>
<circle cx="74.5" cy="60.1" r="0.2"/>
<circle cx="78.3" cy="60.1" r="0.2"/>
<circle cx="50.2" cy="59.4" r="0.2"/>
<circle cx="50.9" cy="59.4" r="0.2"/>
<circle cx="51.6" cy="59.4" r="0.2"/>
<circle cx="52.4" cy="59.4" r="0.2"/>
<circle cx="53.1" cy="59.4" r="0.2"/>
<circle cx="53.8" cy="59.4" r="0.2"/>
<circle cx="54.6" cy="59.4" r="0.2"/>
<circle cx="55.3" cy="59.4" r="0.2"/>
<circle cx="56.1" cy="59.4" r="0.2"/>
<circle cx="56.8" cy="59.4" r="0.2"/>
<circle cx="58.3" cy="59.4" r="0.2"/>
<circle cx="59" cy="59.4" r="0.2"/>
<circle cx="59.8" cy="59.4" r="0.2"/>
<circle cx="60.5" cy="59.4" r="0.2"/>
<circle cx="61.2" cy="59.4" r="0.2"/>
<circle cx="66.4" cy="59.4" r="0.2"/>
<circle cx="67.2" cy="59.4" r="0.2"/>
<circle cx="67.9" cy="59.4" r="0.2"/>
<circle cx="68.6" cy="59.4" r="0.2"/>
<circle cx="71.6" cy="59.4" r="0.2"/>
<circle cx="72.3" cy="59.4" r="0.2"/>
<circle cx="73.1" cy="59.4" r="0.2"/>
<circle cx="73.8" cy="59.4" r="0.2"/>
<circle cx="75.3" cy="59.4" r="0.2"/>
<circle cx="78.3" cy="59.4" r="0.2"/>
<circle cx="50.2" cy="58.6" r="0.2"/>
<circle cx="50.9" cy="58.6" r="0.2"/>
<circle cx="51.6" cy="58.6" r="0.2"/>
<circle cx="52.4" cy="58.6" r="0.2"/>
<circle cx="53.1" cy="58.6" r="0.2"/>
<circle cx="53.8" cy="58.6" r="0.2"/>
<circle cx="54.6" cy="58.6" r="0.2"/>
<circle cx="55.3" cy="58.6" r="0.2"/>
<circle cx="56.1" cy="58.6" r="0.2"/>
<circle cx="57.5" cy="58.6" r="0.2"/>
<circle cx="58.3" cy="58.6" r="0.2"/>
<circle cx="59" cy="58.6" r="0.2"/>
<circle cx="59.8" cy="58.6" r="0.2"/>
<circle cx="60.5" cy="58.6" r="0.2"/>
<circle cx="61.2" cy="58.6" r="0.2"/>
<circle cx="62" cy="58.6" r="0.2"/>
<circle cx="64.9" cy="58.6" r="0.2"/>
<circle cx="66.4" cy="58.6" r="0.2"/>
<circle cx="67.2" cy="58.6" r="0.2"/>
<circle cx="67.9" cy="58.6" r="0.2"/>
<circle cx="68.6" cy="58.6" r="0.2"/>
<circle cx="69.4" cy="58.6" r="0.2"/>
<circle cx="70.9" cy="58.6" r="0.2"/>
<circle cx="71.6" cy="58.6" r="0.2"/>
<circle cx="72.3" cy="58.6" r="0.2"/>
<circle cx="73.1" cy="58.6" r="0.2"/>
<circle cx="73.8" cy="58.6" r="0.2"/>
<circle cx="75.3" cy="58.6" r="0.2"/>
<circle cx="50.2" cy="57.9" r="0.2"/>
<circle cx="50.9" cy="57.9" r="0.2"/>
<circle cx="51.6" cy="57.9" r="0.2"/>
<circle cx="52.4" cy="57.9" r="0.2"/>
<circle cx="53.1" cy="57.9" r="0.2"/>
<circle cx="53.8" cy="57.9" r="0.2"/>
<circle cx="54.6" cy="57.9" r="0.2"/>
<circle cx="55.3" cy="57.9" r="0.2"/>
<circle cx="56.1" cy="57.9" r="0.2"/>
<circle cx="57.5" cy="57.9" r="0.2"/>
<circle cx="58.3" cy="57.9" r="0.2"/>
<circle cx="59" cy="57.9" r="0.2"/>
<circle cx="59.8" cy="57.9" r="0.2"/>
<circle cx="60.5" cy="57.9" r="0.2"/>
<circle cx="61.2" cy="57.9" r="0.2"/>
<circle cx="64.9" cy="57.9" r="0.2"/>
<circle cx="65.7" cy="57.9" r="0.2"/>
<circle cx="66.4" cy="57.9" r="0.2"/>
<circle cx="67.2" cy="57.9" r="0.2"/>
<circle cx="67.9" cy="57.9" r="0.2"/>
<circle cx="68.6" cy="57.9" r="0.2"/>
<circle cx="69.4" cy="57.9" r="0.2"/>
<circle cx="70.1" cy="57.9" r="0.2"/>
<circle cx="70.9" cy="57.9" r="0.2"/>
<circle cx="71.6" cy="57.9" r="0.2"/>
<circle cx="72.3" cy="57.9" r="0.2"/>
<circle cx="73.1" cy="57.9" r="0.2"/>
<circle cx="73.8" cy="57.9" r="0.2"/>
<circle cx="74.5" cy="57.9" r="0.2"/>
<circle cx="75.3" cy="57.9" r="0.2"/>
<circle cx="76" cy="57.9" r="0.2"/>
<circle cx="76.8" cy="57.9" r="0.2"/>
<circle cx="78.3" cy="57.9" r="0.2"/>
<circle cx="50.2" cy="57.2" r="0.2"/>
<circle cx="50.9" cy="57.2" r="0.2"/>
<circle cx="51.6" cy="57.2" r="0.2"/>
<circle cx="52.4" cy="57.2" r="0.2"/>
<circle cx="53.1" cy="57.2" r="0.2"/>
<circle cx="53.8" cy="57.2" r="0.2"/>
<circle cx="54.6" cy="57.2" r="0.2"/>
<circle cx="55.3" cy="57.2" r="0.2"/>
<circle cx="56.8" cy="57.2" r="0.2"/>
<circle cx="57.5" cy="57.2" r="0.2"/>
<circle cx="58.3" cy="57.2" r="0.2"/>
<circle cx="59" cy="57.2" r="0.2"/>
<circle cx="59.8" cy="57.2" r="0.2"/>
<circle cx="62" cy="57.2" r="0.2"/>
<circle cx="62.7" cy="57.2" r="0.2"/>
<circle cx="63.5" cy="57.2" r="0.2"/>
<circle cx="64.2" cy="57.2" r="0.2"/>
<circle cx="64.9" cy="57.2" r="0.2"/>
<circle cx="65.7" cy="57.2" r="0.2"/>
<circle cx="66.4" cy="57.2" r="0.2"/>
<circle cx="67.2" cy="57.2" r="0.2"/>
<circle cx="67.9" cy="57.2" r="0.2"/>
<circle cx="68.6" cy="57.2" r="0.2"/>
<circle cx="69.4" cy="57.2" r="0.2"/>
<circle cx="70.1" cy="57.2" r="0.2"/>
<circle cx="70.9" cy="57.2" r="0.2"/>
<circle cx="71.6" cy="57.2" r="0.2"/>
<circle cx="72.3" cy="57.2" r="0.2"/>
<circle cx="73.1" cy="57.2" r="0.2"/>
<circle cx="73.8" cy="57.2" r="0.2"/>
<circle cx="74.5" cy="57.2" r="0.2"/>
<circle cx="75.3" cy="57.2" r="0.2"/>
<circle cx="76" cy="57.2" r="0.2"/>
<circle cx="76.8" cy="57.2" r="0.2"/>
<circle cx="77.5" cy="57.2" r="0.2"/>
<circle cx="50.2" cy="56.4" r="0.2"/>
<circle cx="50.9" cy="56.4" r="0.2"/>
<circle cx="51.6" cy="56.4" r="0.2"/>
<circle cx="52.4" cy="56.4" r="0.2"/>
<circle cx="53.1" cy="56.4" r="0.2"/>
<circle cx="53.8" cy="56.4" r="0.2"/>
<circle cx="54.6" cy="56.4" r="0.2"/>
<circle cx="55.3" cy="56.4" r="0.2"/>
<circle cx="56.1" cy="56.4" r="0.2"/>
<circle cx="56.8" cy="56.4" r="0.2"/>
<circle cx="57.5" cy="56.4" r="0.2"/>
<circle cx="58.3" cy="56.4" r="0.2"/>
<circle cx="59" cy="56.4" r="0.2"/>
<circle cx="60.5" cy="56.4" r="0.2"/>
<circle cx="61.2" cy="56.4" r="0.2"/>
<circle cx="62" cy="56.4" r="0.2"/>
<circle cx="62.7" cy="56.4" r="0.2"/>
<circle cx="63.5" cy="56.4" r="0.2"/>
<circle cx="64.2" cy="56.4" r="0.2"/>
<circle cx="64.9" cy="56.4" r="0.2"/>
<circle cx="65.7" cy="56.4" r="0.2"/>
<circle cx="66.4" cy="56.4" r="0.2"/>
<circle cx="67.2" cy="56.4" r="0.2"/>
<circle cx="67.9" cy="56.4" r="0.2"/>
<circle cx="68.6" cy="56.4" r="0.2"/>
<circle cx="69.4" cy="56.4" r="0.2"/>
<circle cx="70.1" cy="56.4" r="0.2"/>
<circle cx="70.9" cy="56.4" r="0.2"/>
<circle cx="71.6" cy="56.4" r="0.2"/>
<circle cx="72.3" cy="56.4" r="0.2"/>
<circle cx="73.1" cy="56.4" r="0.2"/>
<circle cx="73.8" cy="56.4" r="0.2"/>
<circle cx="74.5" cy="56.4" r="0.2"/>
<circle cx="75.3" cy="56.4" r="0.2"/>
<circle cx="76" cy="56.4" r="0.2"/>
<circle cx="76.8" cy="56.4" r="0.2"/>
<circle cx="77.5" cy="56.4" r="0.2"/>
<circle cx="78.3" cy="56.4" r="0.2"/>
<circle cx="50.2" cy="55.7" r="0.2"/>
<circle cx="50.9" cy="55.7" r="0.2"/>
<circle cx="52.4" cy="55.7" r="0.2"/>
<circle cx="53.1" cy="55.7" r="0.2"/>
<circle cx="56.1" cy="55.7" r="0.2"/>
<circle cx="56.8" cy="55.7" r="0.2"/>
<circle cx="57.5" cy="55.7" r="0.2"/>
<circle cx="58.3" cy="55.7" r="0.2"/>
<circle cx="59" cy="55.7" r="0.2"/>
<circle cx="59.8" cy="55.7" r="0.2"/>
<circle cx="60.5" cy="55.7" r="0.2"/>
<circle cx="61.2" cy="55.7" r="0.2"/>
<circle cx="62" cy="55.7" r="0.2"/>
<circle cx="62.7" cy="55.7" r="0.2"/>
<circle cx="63.5" cy="55.7" r="0.2"/>
<circle cx="64.2" cy="55.7" r="0.2"/>
<circle cx="64.9" cy="55.7" r="0.2"/>
<circle cx="65.7" cy="55.7" r="0.2"/>
<circle cx="66.4" cy="55.7" r="0.2"/>
<circle cx="67.2" cy="55.7" r="0.2"/>
<circle cx="67.9" cy="55.7" r="0.2"/>
<circle cx="68.6" cy="55.7" r="0.2"/>
<circle cx="69.4" cy="55.7" r="0.2"/>
<circle cx="70.1" cy="55.7" r="0.2"/>
<circle cx="70.9" cy="55.7" r="0.2"/>
<circle cx="71.6" cy="55.7" r="0.2"/>
<circle cx="72.3" cy="55.7" r="0.2"/>
<circle cx="73.1" cy="55.7" r="0.2"/>
<circle cx="73.8" cy="55.7" r="0.2"/>
<circle cx="74.5" cy="55.7" r="0.2"/>
<circle cx="75.3" cy="55.7" r="0.2"/>
<circle cx="76" cy="55.7" r="0.2"/>
<circle cx="76.8" cy="55.7" r="0.2"/>
<circle cx="77.5" cy="55.7" r="0.2"/>
<circle cx="78.3" cy="55.7" r="0.2"/>
<circle cx="56.8" cy="54.9" r="0.2"/>
<circle cx="57.5" cy="54.9" r="0.2"/>
<circle cx="58.3" cy="54.9" r="0.2"/>
<circle cx="59" cy="54.9" r="0.2"/>
<circle cx="59.8" cy="54.9" r="0.2"/>
<circle cx="60.5" cy="54.9" r="0.2"/>
<circle cx="61.2" cy="54.9" r="0.2"/>
<circle cx="62" cy="54.9" r="0.2"/>
<circle cx="62.7" cy="54.9" r="0.2"/>
<circle cx="63.5" cy="54.9" r="0.2"/>
<circle cx="64.2" cy="54.9" r="0.2"/>
<circle cx="64.9" cy="54.9" r="0.2"/>
<circle cx="65.7" cy="54.9" r="0.2"/>
<circle cx="66.4" cy="54.9" r="0.2"/>
<circle cx="67.2" cy="54.9" r="0.2"/>
<circle cx="67.9" cy="54.9" r="0.2"/>
<circle cx="68.6" cy="54.9" r="0.2"/>
<circle cx="69.4" cy="54.9" r="0.2"/>
<circle cx="70.1" cy="54.9" r="0.2"/>
<circle cx="70.9" cy="54.9" r="0.2"/>
<circle cx="71.6" cy="54.9" r="0.2"/>
<circle cx="72.3" cy="54.9" r="0.2"/>
<circle cx="73.1" cy="54.9" r="0.2"/>
<circle cx="73.8" cy="54.9" r="0.2"/>
<circle cx="74.5" cy="54.9" r="0.2"/>
<circle cx="75.3" cy="54.9" r="0.2"/>
<circle cx="76" cy="54.9" r="0.2"/>
<circle cx="76.8" cy="54.9" r="0.2"/>
<circle cx="77.5" cy="54.9" r="0.2"/>
<circle cx="50.9" cy="54.2" r="0.2"/>
<circle cx="53.1" cy="54.2" r="0.2"/>
<circle cx="55.3" cy="54.2" r="0.2"/>
<circle cx="56.8" cy="54.2" r="0.2"/>
<circle cx="57.6" cy="54.2" r="0.2"/>
<circle cx="58.3" cy="54.2" r="0.2"/>
<circle cx="59" cy="54.2" r="0.2"/>
<circle cx="59.8" cy="54.2" r="0.2"/>
<circle cx="61.2" cy="54.2" r="0.2"/>
<circle cx="62" cy="54.2" r="0.2"/>
<circle cx="62.7" cy="54.2" r="0.2"/>
<circle cx="63.5" cy="54.2" r="0.2"/>
<circle cx="64.2" cy="54.2" r="0.2"/>
<circle cx="64.9" cy="54.2" r="0.2"/>
<circle cx="65.7" cy="54.2" r="0.2"/>
<circle cx="66.4" cy="54.2" r="0.2"/>
<circle cx="67.2" cy="54.2" r="0.2"/>
<circle cx="67.9" cy="54.2" r="0.2"/>
<circle cx="68.6" cy="54.2" r="0.2"/>
<circle cx="69.4" cy="54.2" r="0.2"/>
<circle cx="70.1" cy="54.2" r="0.2"/>
<circle cx="70.9" cy="54.2" r="0.2"/>
<circle cx="71.6" cy="54.2" r="0.2"/>
<circle cx="72.3" cy="54.2" r="0.2"/>
<circle cx="73.1" cy="54.2" r="0.2"/>
<circle cx="73.8" cy="54.2" r="0.2"/>
<circle cx="74.6" cy="54.2" r="0.2"/>
<circle cx="75.3" cy="54.2" r="0.2"/>
<circle cx="76" cy="54.2" r="0.2"/>
<circle cx="76.8" cy="54.2" r="0.2"/>
<circle cx="77.5" cy="54.2" r="0.2"/>
<circle cx="78.3" cy="54.2" r="0.2"/>
<circle cx="79.7" cy="54.2" r="0.2"/>
<circle cx="53.1" cy="53.5" r="0.2"/>
<circle cx="54.6" cy="53.5" r="0.2"/>
<circle cx="55.3" cy="53.5" r="0.2"/>
<circle cx="56.1" cy="53.5" r="0.2"/>
<circle cx="56.8" cy="53.5" r="0.2"/>
<circle cx="57.6" cy="53.5" r="0.2"/>
<circle cx="58.3" cy="53.5" r="0.2"/>
<circle cx="59" cy="53.5" r="0.2"/>
<circle cx="61.2" cy="53.5" r="0.2"/>
<circle cx="62" cy="53.5" r="0.2"/>
<circle cx="62.7" cy="53.5" r="0.2"/>
<circle cx="63.5" cy="53.5" r="0.2"/>
<circle cx="64.2" cy="53.5" r="0.2"/>
<circle cx="64.9" cy="53.5" r="0.2"/>
<circle cx="65.7" cy="53.5" r="0.2"/>
<circle cx="66.4" cy="53.5" r="0.2"/>
<circle cx="67.2" cy="53.5" r="0.2"/>
<circle cx="67.9" cy="53.5" r="0.2"/>
<circle cx="68.6" cy="53.5" r="0.2"/>
<circle cx="69.4" cy="53.5" r="0.2"/>
<circle cx="70.1" cy="53.5" r="0.2"/>
<circle cx="70.9" cy="53.5" r="0.2"/>
<circle cx="71.6" cy="53.5" r="0.2"/>
<circle cx="72.3" cy="53.5" r="0.2"/>
<circle cx="73.1" cy="53.5" r="0.2"/>
<circle cx="73.8" cy="53.5" r="0.2"/>
<circle cx="74.6" cy="53.5" r="0.2"/>
<circle cx="75.3" cy="53.5" r="0.2"/>
<circle cx="76" cy="53.5" r="0.2"/>
<circle cx="76.8" cy="53.5" r="0.2"/>
<circle cx="77.5" cy="53.5" r="0.2"/>
<circle cx="79.7" cy="53.5" r="0.2"/>
<circle cx="50.9" cy="52.7" r="0.2"/>
<circle cx="52.4" cy="52.7" r="0.2"/>
<circle cx="53.1" cy="52.7" r="0.2"/>
<circle cx="53.8" cy="52.7" r="0.2"/>
<circle cx="54.6" cy="52.7" r="0.2"/>
<circle cx="55.3" cy="52.7" r="0.2"/>
<circle cx="56.1" cy="52.7" r="0.2"/>
<circle cx="57.6" cy="52.7" r="0.2"/>
<circle cx="58.3" cy="52.7" r="0.2"/>
<circle cx="59" cy="52.7" r="0.2"/>
<circle cx="59.8" cy="52.7" r="0.2"/>
<circle cx="61.2" cy="52.7" r="0.2"/>
<circle cx="62" cy="52.7" r="0.2"/>
<circle cx="62.7" cy="52.7" r="0.2"/>
<circle cx="63.5" cy="52.7" r="0.2"/>
<circle cx="64.2" cy="52.7" r="0.2"/>
<circle cx="64.9" cy="52.7" r="0.2"/>
<circle cx="65.7" cy="52.7" r="0.2"/>
<circle cx="66.4" cy="52.7" r="0.2"/>
<circle cx="67.2" cy="52.7" r="0.2"/>
<circle cx="67.9" cy="52.7" r="0.2"/>
<circle cx="68.6" cy="52.7" r="0.2"/>
<circle cx="69.4" cy="52.7" r="0.2"/>
<circle cx="70.1" cy="52.7" r="0.2"/>
<circle cx="70.9" cy="52.7" r="0.2"/>
<circle cx="71.6" cy="52.7" r="0.2"/>
<circle cx="72.3" cy="52.7" r="0.2"/>
<circle cx="73.1" cy="52.7" r="0.2"/>
<circle cx="73.8" cy="52.7" r="0.2"/>
<circle cx="74.6" cy="52.7" r="0.2"/>
<circle cx="75.3" cy="52.7" r="0.2"/>
<circle cx="76" cy="52.7" r="0.2"/>
<circle cx="76.8" cy="52.7" r="0.2"/>
<circle cx="77.5" cy="52.7" r="0.2"/>
<circle cx="78.3" cy="52.7" r="0.2"/>
<circle cx="79" cy="52.7" r="0.2"/>
<circle cx="79.7" cy="52.7" r="0.2"/>
<circle cx="83.4" cy="52.7" r="0.2"/>
<circle cx="50.2" cy="52" r="0.2"/>
<circle cx="51.6" cy="52" r="0.2"/>
<circle cx="52.4" cy="52" r="0.2"/>
<circle cx="53.1" cy="52" r="0.2"/>
<circle cx="53.8" cy="52" r="0.2"/>
<circle cx="58.3" cy="52" r="0.2"/>
<circle cx="59" cy="52" r="0.2"/>
<circle cx="60.5" cy="52" r="0.2"/>
<circle cx="61.2" cy="52" r="0.2"/>
<circle cx="62" cy="52" r="0.2"/>
<circle cx="62.7" cy="52" r="0.2"/>
<circle cx="63.5" cy="52" r="0.2"/>
<circle cx="64.2" cy="52" r="0.2"/>
<circle cx="64.9" cy="52" r="0.2"/>
<circle cx="65.7" cy="52" r="0.2"/>
<circle cx="66.4" cy="52" r="0.2"/>
<circle cx="67.2" cy="52" r="0.2"/>
<circle cx="67.9" cy="52" r="0.2"/>
<circle cx="68.6" cy="52" r="0.2"/>
<circle cx="69.4" cy="52" r="0.2"/>
<circle cx="70.1" cy="52" r="0.2"/>
<circle cx="70.9" cy="52" r="0.2"/>
<circle cx="71.6" cy="52" r="0.2"/>
<circle cx="72.3" cy="52" r="0.2"/>
<circle cx="73.1" cy="52" r="0.2"/>
<circle cx="73.8" cy="52" r="0.2"/>
<circle cx="74.6" cy="52" r="0.2"/>
<circle cx="75.3" cy="52" r="0.2"/>
<circle cx="76" cy="52" r="0.2"/>
<circle cx="76.8" cy="52" r="0.2"/>
<circle cx="77.5" cy="52" r="0.2"/>
<circle cx="78.3" cy="52" r="0.2"/>
<circle cx="79" cy="52" r="0.2"/>
<circle cx="79.7" cy="52" r="0.2"/>
<circle cx="80.5" cy="52" r="0.2"/>
<circle cx="81.2" cy="52" r="0.2"/>
<circle cx="83.4" cy="52" r="0.2"/>
<circle cx="84.2" cy="52" r="0.2"/>
<circle cx="50.2" cy="51.2" r="0.2"/>
<circle cx="50.9" cy="51.2" r="0.2"/>
<circle cx="51.6" cy="51.2" r="0.2"/>
<circle cx="52.4" cy="51.2" r="0.2"/>
<circle cx="53.1" cy="51.2" r="0.2"/>
<circle cx="53.8" cy="51.2" r="0.2"/>
<circle cx="54.6" cy="51.2" r="0.2"/>
<circle cx="56.1" cy="51.2" r="0.2"/>
<circle cx="57.6" cy="51.2" r="0.2"/>
<circle cx="58.3" cy="51.2" r="0.2"/>
<circle cx="59" cy="51.2" r="0.2"/>
<circle cx="60.5" cy="51.2" r="0.2"/>
<circle cx="61.2" cy="51.2" r="0.2"/>
<circle cx="62" cy="51.2" r="0.2"/>
<circle cx="62.7" cy="51.2" r="0.2"/>
<circle cx="63.5" cy="51.2" r="0.2"/>
<circle cx="64.2" cy="51.2" r="0.2"/>
<circle cx="64.9" cy="51.2" r="0.2"/>
<circle cx="65.7" cy="51.2" r="0.2"/>
<circle cx="66.4" cy="51.2" r="0.2"/>
<circle cx="67.2" cy="51.2" r="0.2"/>
<circle cx="67.9" cy="51.2" r="0.2"/>
<circle cx="68.6" cy="51.2" r="0.2"/>
<circle cx="69.4" cy="51.2" r="0.2"/>
<circle cx="70.1" cy="51.2" r="0.2"/>
<circle cx="70.9" cy="51.2" r="0.2"/>
<circle cx="71.6" cy="51.2" r="0.2"/>
<circle cx="72.3" cy="51.2" r="0.2"/>
<circle cx="73.1" cy="51.2" r="0.2"/>
<circle cx="73.8" cy="51.2" r="0.2"/>
<circle cx="74.6" cy="51.2" r="0.2"/>
<circle cx="75.3" cy="51.2" r="0.2"/>
<circle cx="76" cy="51.2" r="0.2"/>
<circle cx="76.8" cy="51.2" r="0.2"/>
<circle cx="77.5" cy="51.2" r="0.2"/>
<circle cx="78.3" cy="51.2" r="0.2"/>
<circle cx="79" cy="51.2" r="0.2"/>
<circle cx="79.7" cy="51.2" r="0.2"/>
<circle cx="80.5" cy="51.2" r="0.2"/>
<circle cx="81.2" cy="51.2" r="0.2"/>
<circle cx="81.9" cy="51.2" r="0.2"/>
<circle cx="83.4" cy="51.2" r="0.2"/>
<circle cx="50.2" cy="50.5" r="0.2"/>
<circle cx="50.9" cy="50.5" r="0.2"/>
<circle cx="51.6" cy="50.5" r="0.2"/>
<circle cx="52.4" cy="50.5" r="0.2"/>
<circle cx="53.1" cy="50.5" r="0.2"/>
<circle cx="53.8" cy="50.5" r="0.2"/>
<circle cx="54.6" cy="50.5" r="0.2"/>
<circle cx="55.3" cy="50.5" r="0.2"/>
<circle cx="56.1" cy="50.5" r="0.2"/>
<circle cx="56.8" cy="50.5" r="0.2"/>
<circle cx="57.6" cy="50.5" r="0.2"/>
<circle cx="58.3" cy="50.5" r="0.2"/>
<circle cx="59" cy="50.5" r="0.2"/>
<circle cx="59.8" cy="50.5" r="0.2"/>
<circle cx="61.2" cy="50.5" r="0.2"/>
<circle cx="62" cy="50.5" r="0.2"/>
<circle cx="62.7" cy="50.5" r="0.2"/>
<circle cx="63.5" cy="50.5" r="0.2"/>
<circle cx="64.2" cy="50.5" r="0.2"/>
<circle cx="64.9" cy="50.5" r="0.2"/>
<circle cx="65.7" cy="50.5" r="0.2"/>
<circle cx="66.4" cy="50.5" r="0.2"/>
<circle cx="67.2" cy="50.5" r="0.2"/>
<circle cx="67.9" cy="50.5" r="0.2"/>
<circle cx="68.6" cy="50.5" r="0.2"/>
<circle cx="69.4" cy="50.5" r="0.2"/>
<circle cx="70.1" cy="50.5" r="0.2"/>
<circle cx="70.9" cy="50.5" r="0.2"/>
<circle cx="71.6" cy="50.5" r="0.2"/>
<circle cx="72.3" cy="50.5" r="0.2"/>
<circle cx="73.1" cy="50.5" r="0.2"/>
<circle cx="73.8" cy="50.5" r="0.2"/>
<circle cx="74.6" cy="50.5" r="0.2"/>
<circle cx="75.3" cy="50.5" r="0.2"/>
<circle cx="76" cy="50.5" r="0.2"/>
<circle cx="76.8" cy="50.5" r="0.2"/>
<circle cx="77.5" cy="50.5" r="0.2"/>
<circle cx="78.3" cy="50.5" r="0.2"/>
<circle cx="79" cy="50.5" r="0.2"/>
<circle cx="79.7" cy="50.5" r="0.2"/>
<circle cx="80.5" cy="50.5" r="0.2"/>
<circle cx="81.2" cy="50.5" r="0.2"/>
<circle cx="81.9" cy="50.5" r="0.2"/>
<circle cx="83.4" cy="50.5" r="0.2"/>
<circle cx="50.2" cy="49.8" r="0.2"/>
<circle cx="50.9" cy="49.8" r="0.2"/>
<circle cx="51.6" cy="49.8" r="0.2"/>
<circle cx="52.4" cy="49.8" r="0.2"/>
<circle cx="53.1" cy="49.8" r="0.2"/>
<circle cx="53.8" cy="49.8" r="0.2"/>
<circle cx="54.6" cy="49.8" r="0.2"/>
<circle cx="55.3" cy="49.8" r="0.2"/>
<circle cx="56.1" cy="49.8" r="0.2"/>
<circle cx="56.8" cy="49.8" r="0.2"/>
<circle cx="57.6" cy="49.8" r="0.2"/>
<circle cx="58.3" cy="49.8" r="0.2"/>
<circle cx="59" cy="49.8" r="0.2"/>
<circle cx="59.8" cy="49.8" r="0.2"/>
<circle cx="60.5" cy="49.8" r="0.2"/>
<circle cx="61.2" cy="49.8" r="0.2"/>
<circle cx="62" cy="49.8" r="0.2"/>
<circle cx="62.7" cy="49.8" r="0.2"/>
<circle cx="63.5" cy="49.8" r="0.2"/>
<circle cx="64.2" cy="49.8" r="0.2"/>
<circle cx="64.9" cy="49.8" r="0.2"/>
<circle cx="65.7" cy="49.8" r="0.2"/>
<circle cx="66.4" cy="49.8" r="0.2"/>
<circle cx="67.2" cy="49.8" r="0.2"/>
<circle cx="67.9" cy="49.8" r="0.2"/>
<circle cx="68.6" cy="49.8" r="0.2"/>
<circle cx="69.4" cy="49.8" r="0.2"/>
<circle cx="70.1" cy="49.8" r="0.2"/>
<circle cx="70.9" cy="49.8" r="0.2"/>
<circle cx="71.6" cy="49.8" r="0.2"/>
<circle cx="72.3" cy="49.8" r="0.2"/>
<circle cx="73.1" cy="49.8" r="0.2"/>
<circle cx="73.8" cy="49.8" r="0.2"/>
<circle cx="74.6" cy="49.8" r="0.2"/>
<circle cx="75.3" cy="49.8" r="0.2"/>
<circle cx="76" cy="49.8" r="0.2"/>
<circle cx="76.8" cy="49.8" r="0.2"/>
<circle cx="77.5" cy="49.8" r="0.2"/>
<circle cx="78.3" cy="49.8" r="0.2"/>
<circle cx="79" cy="49.8" r="0.2"/>
<circle cx="79.7" cy="49.8" r="0.2"/>
<circle cx="80.5" cy="49.8" r="0.2"/>
<circle cx="81.2" cy="49.8" r="0.2"/>
<circle cx="81.9" cy="49.8" r="0.2"/>
<circle cx="82.7" cy="49.8" r="0.2"/>
<circle cx="84.2" cy="49.8" r="0.2"/>
<circle cx="50.2" cy="49" r="0.2"/>
<circle cx="50.9" cy="49" r="0.2"/>
<circle cx="51.6" cy="49" r="0.2"/>
<circle cx="52.4" cy="49" r="0.2"/>
<circle cx="53.1" cy="49" r="0.2"/>
<circle cx="53.8" cy="49" r="0.2"/>
<circle cx="54.6" cy="49" r="0.2"/>
<circle cx="55.3" cy="49" r="0.2"/>
<circle cx="56.1" cy="49" r="0.2"/>
<circle cx="56.8" cy="49" r="0.2"/>
<circle cx="57.6" cy="49" r="0.2"/>
<circle cx="58.3" cy="49" r="0.2"/>
<circle cx="59" cy="49" r="0.2"/>
<circle cx="59.8" cy="49" r="0.2"/>
<circle cx="60.5" cy="49" r="0.2"/>
<circle cx="61.2" cy="49" r="0.2"/>
<circle cx="62" cy="49" r="0.2"/>
<circle cx="62.7" cy="49" r="0.2"/>
<circle cx="63.5" cy="49" r="0.2"/>
<circle cx="64.2" cy="49" r="0.2"/>
<circle cx="64.9" cy="49" r="0.2"/>
<circle cx="65.7" cy="49" r="0.2"/>
<circle cx="66.4" cy="49" r="0.2"/>
<circle cx="67.2" cy="49" r="0.2"/>
<circle cx="67.9" cy="49" r="0.2"/>
<circle cx="68.6" cy="49" r="0.2"/>
<circle cx="69.4" cy="49" r="0.2"/>
<circle cx="70.1" cy="49" r="0.2"/>
<circle cx="70.9" cy="49" r="0.2"/>
<circle cx="71.6" cy="49" r="0.2"/>
<circle cx="72.3" cy="49" r="0.2"/>
<circle cx="73.1" cy="49" r="0.2"/>
<circle cx="73.8" cy="49" r="0.2"/>
<circle cx="74.6" cy="49" r="0.2"/>
<circle cx="75.3" cy="49" r="0.2"/>
<circle cx="76" cy="49" r="0.2"/>
<circle cx="76.8" cy="49" r="0.2"/>
<circle cx="77.5" cy="49" r="0.2"/>
<circle cx="78.3" cy="49" r="0.2"/>
<circle cx="79" cy="49" r="0.2"/>
<circle cx="79.7" cy="49" r="0.2"/>
<circle cx="80.5" cy="49" r="0.2"/>
<circle cx="81.2" cy="49" r="0.2"/>
<circle cx="81.9" cy="49" r="0.2"/>
<circle cx="82.7" cy="49" r="0.2"/>
<circle cx="50.2" cy="48.4" r="0.2"/>
<circle cx="50.9" cy="48.4" r="0.2"/>
<circle cx="51.6" cy="48.4" r="0.2"/>
<circle cx="52.4" cy="48.4" r="0.2"/>
<circle cx="53.1" cy="48.4" r="0.2"/>
<circle cx="53.8" cy="48.4" r="0.2"/>
<circle cx="54.6" cy="48.4" r="0.2"/>
<circle cx="55.3" cy="48.4" r="0.2"/>
<circle cx="56.1" cy="48.4" r="0.2"/>
<circle cx="56.8" cy="48.4" r="0.2"/>
<circle cx="57.6" cy="48.4" r="0.2"/>
<circle cx="58.3" cy="48.4" r="0.2"/>
<circle cx="59" cy="48.4" r="0.2"/>
<circle cx="59.8" cy="48.4" r="0.2"/>
<circle cx="60.5" cy="48.4" r="0.2"/>
<circle cx="61.2" cy="48.4" r="0.2"/>
<circle cx="62" cy="48.4" r="0.2"/>
<circle cx="62.7" cy="48.4" r="0.2"/>
<circle cx="63.5" cy="48.4" r="0.2"/>
<circle cx="64.2" cy="48.4" r="0.2"/>
<circle cx="64.9" cy="48.4" r="0.2"/>
<circle cx="65.7" cy="48.4" r="0.2"/>
<circle cx="66.4" cy="48.4" r="0.2"/>
<circle cx="67.2" cy="48.4" r="0.2"/>
<circle cx="67.9" cy="48.4" r="0.2"/>
<circle cx="68.6" cy="48.4" r="0.2"/>
<circle cx="69.4" cy="48.4" r="0.2"/>
<circle cx="70.1" cy="48.4" r="0.2"/>
<circle cx="70.9" cy="48.4" r="0.2"/>
<circle cx="71.6" cy="48.4" r="0.2"/>
<circle cx="72.3" cy="48.4" r="0.2"/>
<circle cx="73.1" cy="48.4" r="0.2"/>
<circle cx="73.8" cy="48.4" r="0.2"/>
<circle cx="74.6" cy="48.4" r="0.2"/>
<circle cx="75.3" cy="48.4" r="0.2"/>
<circle cx="76" cy="48.4" r="0.2"/>
<circle cx="76.8" cy="48.4" r="0.2"/>
<circle cx="77.5" cy="48.4" r="0.2"/>
<circle cx="78.3" cy="48.4" r="0.2"/>
<circle cx="79" cy="48.4" r="0.2"/>
<circle cx="79.7" cy="48.4" r="0.2"/>
<circle cx="80.5" cy="48.4" r="0.2"/>
<circle cx="81.2" cy="48.4" r="0.2"/>
<circle cx="82" cy="48.4" r="0.2"/>
<circle cx="82.7" cy="48.4" r="0.2"/>
<circle cx="83.4" cy="48.4" r="0.2"/>
<circle cx="87.1" cy="48.4" r="0.2"/>
<circle cx="51.6" cy="47.6" r="0.2"/>
<circle cx="52.4" cy="47.6" r="0.2"/>
<circle cx="53.1" cy="47.6" r="0.2"/>
<circle cx="53.8" cy="47.6" r="0.2"/>
<circle cx="54.6" cy="47.6" r="0.2"/>
<circle cx="55.3" cy="47.6" r="0.2"/>
<circle cx="56.1" cy="47.6" r="0.2"/>
<circle cx="56.8" cy="47.6" r="0.2"/>
<circle cx="57.6" cy="47.6" r="0.2"/>
<circle cx="58.3" cy="47.6" r="0.2"/>
<circle cx="59" cy="47.6" r="0.2"/>
<circle cx="59.8" cy="47.6" r="0.2"/>
<circle cx="60.5" cy="47.6" r="0.2"/>
<circle cx="61.2" cy="47.6" r="0.2"/>
<circle cx="62" cy="47.6" r="0.2"/>
<circle cx="62.7" cy="47.6" r="0.2"/>
<circle cx="63.5" cy="47.6" r="0.2"/>
<circle cx="64.2" cy="47.6" r="0.2"/>
<circle cx="64.9" cy="47.6" r="0.2"/>
<circle cx="65.7" cy="47.6" r="0.2"/>
<circle cx="66.4" cy="47.6" r="0.2"/>
<circle cx="67.2" cy="47.6" r="0.2"/>
<circle cx="67.9" cy="47.6" r="0.2"/>
<circle cx="68.6" cy="47.6" r="0.2"/>
<circle cx="69.4" cy="47.6" r="0.2"/>
<circle cx="70.1" cy="47.6" r="0.2"/>
<circle cx="70.9" cy="47.6" r="0.2"/>
<circle cx="71.6" cy="47.6" r="0.2"/>
<circle cx="72.3" cy="47.6" r="0.2"/>
<circle cx="73.1" cy="47.6" r="0.2"/>
<circle cx="73.8" cy="47.6" r="0.2"/>
<circle cx="74.6" cy="47.6" r="0.2"/>
<circle cx="75.3" cy="47.6" r="0.2"/>
<circle cx="76" cy="47.6" r="0.2"/>
<circle cx="76.8" cy="47.6" r="0.2"/>
<circle cx="77.5" cy="47.6" r="0.2"/>
<circle cx="78.3" cy="47.6" r="0.2"/>
<circle cx="79" cy="47.6" r="0.2"/>
<circle cx="79.7" cy="47.6" r="0.2"/>
<circle cx="80.5" cy="47.6" r="0.2"/>
<circle cx="81.2" cy="47.6" r="0.2"/>
<circle cx="82" cy="47.6" r="0.2"/>
<circle cx="82.7" cy="47.6" r="0.2"/>
<circle cx="87.1" cy="47.6" r="0.2"/>
<circle cx="87.9" cy="47.6" r="0.2"/>
<circle cx="50.2" cy="46.9" r="0.2"/>
<circle cx="50.9" cy="46.9" r="0.2"/>
<circle cx="53.1" cy="46.9" r="0.2"/>
<circle cx="53.8" cy="46.9" r="0.2"/>
<circle cx="54.6" cy="46.9" r="0.2"/>
<circle cx="55.3" cy="46.9" r="0.2"/>
<circle cx="56.1" cy="46.9" r="0.2"/>
<circle cx="56.8" cy="46.9" r="0.2"/>
<circle cx="57.6" cy="46.9" r="0.2"/>
<circle cx="58.3" cy="46.9" r="0.2"/>
<circle cx="59" cy="46.9" r="0.2"/>
<circle cx="59.8" cy="46.9" r="0.2"/>
<circle cx="60.5" cy="46.9" r="0.2"/>
<circle cx="61.2" cy="46.9" r="0.2"/>
<circle cx="62" cy="46.9" r="0.2"/>
<circle cx="62.7" cy="46.9" r="0.2"/>
<circle cx="63.5" cy="46.9" r="0.2"/>
<circle cx="64.2" cy="46.9" r="0.2"/>
<circle cx="64.9" cy="46.9" r="0.2"/>
<circle cx="65.7" cy="46.9" r="0.2"/>
<circle cx="66.4" cy="46.9" r="0.2"/>
<circle cx="67.2" cy="46.9" r="0.2"/>
<circle cx="67.9" cy="46.9" r="0.2"/>
<circle cx="68.6" cy="46.9" r="0.2"/>
<circle cx="69.4" cy="46.9" r="0.2"/>
<circle cx="70.1" cy="46.9" r="0.2"/>
<circle cx="70.9" cy="46.9" r="0.2"/>
<circle cx="71.6" cy="46.9" r="0.2"/>
<circle cx="72.3" cy="46.9" r="0.2"/>
<circle cx="73.1" cy="46.9" r="0.2"/>
<circle cx="73.8" cy="46.9" r="0.2"/>
<circle cx="74.6" cy="46.9" r="0.2"/>
<circle cx="75.3" cy="46.9" r="0.2"/>
<circle cx="76" cy="46.9" r="0.2"/>
<circle cx="76.8" cy="46.9" r="0.2"/>
<circle cx="77.5" cy="46.9" r="0.2"/>
<circle cx="78.3" cy="46.9" r="0.2"/>
<circle cx="79" cy="46.9" r="0.2"/>
<circle cx="79.7" cy="46.9" r="0.2"/>
<circle cx="80.5" cy="46.9" r="0.2"/>
<circle cx="81.2" cy="46.9" r="0.2"/>
<circle cx="82" cy="46.9" r="0.2"/>
<circle cx="87.1" cy="46.9" r="0.2"/>
<circle cx="87.9" cy="46.9" r="0.2"/>
<circle cx="88.6" cy="46.9" r="0.2"/>
<circle cx="50.9" cy="46.1" r="0.2"/>
<circle cx="53.8" cy="46.1" r="0.2"/>
<circle cx="54.6" cy="46.1" r="0.2"/>
<circle cx="55.3" cy="46.1" r="0.2"/>
<circle cx="56.1" cy="46.1" r="0.2"/>
<circle cx="56.8" cy="46.1" r="0.2"/>
<circle cx="57.6" cy="46.1" r="0.2"/>
<circle cx="58.3" cy="46.1" r="0.2"/>
<circle cx="59" cy="46.1" r="0.2"/>
<circle cx="59.8" cy="46.1" r="0.2"/>
<circle cx="60.5" cy="46.1" r="0.2"/>
<circle cx="61.2" cy="46.1" r="0.2"/>
<circle cx="62" cy="46.1" r="0.2"/>
<circle cx="62.7" cy="46.1" r="0.2"/>
<circle cx="63.5" cy="46.1" r="0.2"/>
<circle cx="64.2" cy="46.1" r="0.2"/>
<circle cx="64.9" cy="46.1" r="0.2"/>
<circle cx="65.7" cy="46.1" r="0.2"/>
<circle cx="66.4" cy="46.1" r="0.2"/>
<circle cx="67.2" cy="46.1" r="0.2"/>
<circle cx="67.9" cy="46.1" r="0.2"/>
<circle cx="68.6" cy="46.1" r="0.2"/>
<circle cx="69.4" cy="46.1" r="0.2"/>
<circle cx="70.1" cy="46.1" r="0.2"/>
<circle cx="70.9" cy="46.1" r="0.2"/>
<circle cx="71.6" cy="46.1" r="0.2"/>
<circle cx="72.3" cy="46.1" r="0.2"/>
<circle cx="73.1" cy="46.1" r="0.2"/>
<circle cx="73.8" cy="46.1" r="0.2"/>
<circle cx="74.6" cy="46.1" r="0.2"/>
<circle cx="75.3" cy="46.1" r="0.2"/>
<circle cx="76" cy="46.1" r="0.2"/>
<circle cx="76.8" cy="46.1" r="0.2"/>
<circle cx="77.5" cy="46.1" r="0.2"/>
<circle cx="78.3" cy="46.1" r="0.2"/>
<circle cx="79" cy="46.1" r="0.2"/>
<circle cx="79.7" cy="46.1" r="0.2"/>
<circle cx="80.5" cy="46.1" r="0.2"/>
<circle cx="81.2" cy="46.1" r="0.2"/>
<circle cx="82" cy="46.1" r="0.2"/>
<circle cx="82.7" cy="46.1" r="0.2"/>
<circle cx="87.9" cy="46.1" r="0.2"/>
<circle cx="88.6" cy="46.1" r="0.2"/>
<circle cx="50.2" cy="45.4" r="0.2"/>
<circle cx="50.9" cy="45.4" r="0.2"/>
<circle cx="51.6" cy="45.4" r="0.2"/>
<circle cx="53.1" cy="45.4" r="0.2"/>
<circle cx="53.8" cy="45.4" r="0.2"/>
<circle cx="54.6" cy="45.4" r="0.2"/>
<circle cx="55.3" cy="45.4" r="0.2"/>
<circle cx="56.1" cy="45.4" r="0.2"/>
<circle cx="56.8" cy="45.4" r="0.2"/>
<circle cx="57.6" cy="45.4" r="0.2"/>
<circle cx="58.3" cy="45.4" r="0.2"/>
<circle cx="59" cy="45.4" r="0.2"/>
<circle cx="59.8" cy="45.4" r="0.2"/>
<circle cx="60.5" cy="45.4" r="0.2"/>
<circle cx="61.2" cy="45.4" r="0.2"/>
<circle cx="62" cy="45.4" r="0.2"/>
<circle cx="62.7" cy="45.4" r="0.2"/>
<circle cx="63.5" cy="45.4" r="0.2"/>
<circle cx="64.2" cy="45.4" r="0.2"/>
<circle cx="64.9" cy="45.4" r="0.2"/>
<circle cx="65.7" cy="45.4" r="0.2"/>
<circle cx="66.4" cy="45.4" r="0.2"/>
<circle cx="67.2" cy="45.4" r="0.2"/>
<circle cx="67.9" cy="45.4" r="0.2"/>
<circle cx="68.6" cy="45.4" r="0.2"/>
<circle cx="69.4" cy="45.4" r="0.2"/>
<circle cx="70.1" cy="45.4" r="0.2"/>
<circle cx="70.9" cy="45.4" r="0.2"/>
<circle cx="71.6" cy="45.4" r="0.2"/>
<circle cx="72.3" cy="45.4" r="0.2"/>
<circle cx="73.1" cy="45.4" r="0.2"/>
<circle cx="73.8" cy="45.4" r="0.2"/>
<circle cx="74.6" cy="45.4" r="0.2"/>
<circle cx="75.3" cy="45.4" r="0.2"/>
<circle cx="76" cy="45.4" r="0.2"/>
<circle cx="76.8" cy="45.4" r="0.2"/>
<circle cx="77.5" cy="45.4" r="0.2"/>
<circle cx="78.3" cy="45.4" r="0.2"/>
<circle cx="79" cy="45.4" r="0.2"/>
<circle cx="79.7" cy="45.4" r="0.2"/>
<circle cx="80.5" cy="45.4" r="0.2"/>
<circle cx="81.2" cy="45.4" r="0.2"/>
<circle cx="82" cy="45.4" r="0.2"/>
<circle cx="82.7" cy="45.4" r="0.2"/>
<circle cx="83.4" cy="45.4" r="0.2"/>
<circle cx="84.9" cy="45.4" r="0.2"/>
<circle cx="86.4" cy="45.4" r="0.2"/>
<circle cx="88.6" cy="45.4" r="0.2"/>
<circle cx="50.2" cy="44.7" r="0.2"/>
<circle cx="50.9" cy="44.7" r="0.2"/>
<circle cx="51.6" cy="44.7" r="0.2"/>
<circle cx="53.1" cy="44.7" r="0.2"/>
<circle cx="54.6" cy="44.7" r="0.2"/>
<circle cx="55.3" cy="44.7" r="0.2"/>
<circle cx="56.1" cy="44.7" r="0.2"/>
<circle cx="56.8" cy="44.7" r="0.2"/>
<circle cx="57.6" cy="44.7" r="0.2"/>
<circle cx="58.3" cy="44.7" r="0.2"/>
<circle cx="59" cy="44.7" r="0.2"/>
<circle cx="59.8" cy="44.7" r="0.2"/>
<circle cx="60.5" cy="44.7" r="0.2"/>
<circle cx="61.2" cy="44.7" r="0.2"/>
<circle cx="62" cy="44.7" r="0.2"/>
<circle cx="62.7" cy="44.7" r="0.2"/>
<circle cx="63.5" cy="44.7" r="0.2"/>
<circle cx="64.2" cy="44.7" r="0.2"/>
<circle cx="64.9" cy="44.7" r="0.2"/>
<circle cx="65.7" cy="44.7" r="0.2"/>
<circle cx="66.4" cy="44.7" r="0.2"/>
<circle cx="67.2" cy="44.7" r="0.2"/>
<circle cx="67.9" cy="44.7" r="0.2"/>
<circle cx="68.6" cy="44.7" r="0.2"/>
<circle cx="69.4" cy="44.7" r="0.2"/>
<circle cx="70.1" cy="44.7" r="0.2"/>
<circle cx="70.9" cy="44.7" r="0.2"/>
<circle cx="71.6" cy="44.7" r="0.2"/>
<circle cx="72.3" cy="44.7" r="0.2"/>
<circle cx="73.1" cy="44.7" r="0.2"/>
<circle cx="73.8" cy="44.7" r="0.2"/>
<circle cx="74.6" cy="44.7" r="0.2"/>
<circle cx="75.3" cy="44.7" r="0.2"/>
<circle cx="76" cy="44.7" r="0.2"/>
<circle cx="76.8" cy="44.7" r="0.2"/>
<circle cx="77.5" cy="44.7" r="0.2"/>
<circle cx="78.3" cy="44.7" r="0.2"/>
<circle cx="79" cy="44.7" r="0.2"/>
<circle cx="79.7" cy="44.7" r="0.2"/>
<circle cx="80.5" cy="44.7" r="0.2"/>
<circle cx="81.2" cy="44.7" r="0.2"/>
<circle cx="82" cy="44.7" r="0.2"/>
<circle cx="82.7" cy="44.7" r="0.2"/>
<circle cx="83.4" cy="44.7" r="0.2"/>
<circle cx="84.2" cy="44.7" r="0.2"/>
<circle cx="84.9" cy="44.7" r="0.2"/>
<circle cx="85.6" cy="44.7" r="0.2"/>
<circle cx="86.4" cy="44.7" r="0.2"/>
<circle cx="88.6" cy="44.7" r="0.2"/>
<circle cx="89.3" cy="44.7" r="0.2"/>
<circle cx="90.1" cy="44.7" r="0.2"/>
<circle cx="90.8" cy="44.7" r="0.2"/>
<circle cx="50.2" cy="43.9" r="0.2"/>
<circle cx="50.9" cy="43.9" r="0.2"/>
<circle cx="51.6" cy="43.9" r="0.2"/>
<circle cx="53.1" cy="43.9" r="0.2"/>
<circle cx="53.8" cy="43.9" r="0.2"/>
<circle cx="54.6" cy="43.9" r="0.2"/>
<circle cx="55.3" cy="43.9" r="0.2"/>
<circle cx="56.1" cy="43.9" r="0.2"/>
<circle cx="56.8" cy="43.9" r="0.2"/>
<circle cx="57.6" cy="43.9" r="0.2"/>
<circle cx="58.3" cy="43.9" r="0.2"/>
<circle cx="59" cy="43.9" r="0.2"/>
<circle cx="59.8" cy="43.9" r="0.2"/>
<circle cx="60.5" cy="43.9" r="0.2"/>
<circle cx="61.2" cy="43.9" r="0.2"/>
<circle cx="62" cy="43.9" r="0.2"/>
<circle cx="62.7" cy="43.9" r="0.2"/>
<circle cx="63.5" cy="43.9" r="0.2"/>
<circle cx="64.2" cy="43.9" r="0.2"/>
<circle cx="64.9" cy="43.9" r="0.2"/>
<circle cx="65.7" cy="43.9" r="0.2"/>
<circle cx="66.4" cy="43.9" r="0.2"/>
<circle cx="67.2" cy="43.9" r="0.2"/>
<circle cx="67.9" cy="43.9" r="0.2"/>
<circle cx="68.6" cy="43.9" r="0.2"/>
<circle cx="69.4" cy="43.9" r="0.2"/>
<circle cx="70.1" cy="43.9" r="0.2"/>
<circle cx="70.9" cy="43.9" r="0.2"/>
<circle cx="71.6" cy="43.9" r="0.2"/>
<circle cx="72.3" cy="43.9" r="0.2"/>
<circle cx="73.1" cy="43.9" r="0.2"/>
<circle cx="73.8" cy="43.9" r="0.2"/>
<circle cx="74.6" cy="43.9" r="0.2"/>
<circle cx="75.3" cy="43.9" r="0.2"/>
<circle cx="76" cy="43.9" r="0.2"/>
<circle cx="76.8" cy="43.9" r="0.2"/>
<circle cx="77.5" cy="43.9" r="0.2"/>
<circle cx="78.3" cy="43.9" r="0.2"/>
<circle cx="79" cy="43.9" r="0.2"/>
<circle cx="79.7" cy="43.9" r="0.2"/>
<circle cx="80.5" cy="43.9" r="0.2"/>
<circle cx="81.2" cy="43.9" r="0.2"/>
<circle cx="82" cy="43.9" r="0.2"/>
<circle cx="82.7" cy="43.9" r="0.2"/>
<circle cx="83.4" cy="43.9" r="0.2"/>
<circle cx="84.2" cy="43.9" r="0.2"/>
<circle cx="84.9" cy="43.9" r="0.2"/>
<circle cx="85.6" cy="43.9" r="0.2"/>
<circle cx="86.4" cy="43.9" r="0.2"/>
<circle cx="87.1" cy="43.9" r="0.2"/>
<circle cx="87.9" cy="43.9" r="0.2"/>
<circle cx="88.6" cy="43.9" r="0.2"/>
<circle cx="89.3" cy="43.9" r="0.2"/>
<circle cx="90.1" cy="43.9" r="0.2"/>
<circle cx="90.8" cy="43.9" r="0.2"/>
<circle cx="91.6" cy="43.9" r="0.2"/>
<circle cx="50.2" cy="43.2" r="0.2"/>
<circle cx="50.9" cy="43.2" r="0.2"/>
<circle cx="51.6" cy="43.2" r="0.2"/>
<circle cx="53.1" cy="43.2" r="0.2"/>
<circle cx="53.8" cy="43.2" r="0.2"/>
<circle cx="54.6" cy="43.2" r="0.2"/>
<circle cx="55.3" cy="43.2" r="0.2"/>
<circle cx="56.1" cy="43.2" r="0.2"/>
<circle cx="56.8" cy="43.2" r="0.2"/>
<circle cx="57.6" cy="43.2" r="0.2"/>
<circle cx="58.3" cy="43.2" r="0.2"/>
<circle cx="59" cy="43.2" r="0.2"/>
<circle cx="59.8" cy="43.2" r="0.2"/>
<circle cx="60.5" cy="43.2" r="0.2"/>
<circle cx="61.2" cy="43.2" r="0.2"/>
<circle cx="62" cy="43.2" r="0.2"/>
<circle cx="62.7" cy="43.2" r="0.2"/>
<circle cx="63.5" cy="43.2" r="0.2"/>
<circle cx="64.2" cy="43.2" r="0.2"/>
<circle cx="64.9" cy="43.2" r="0.2"/>
<circle cx="65.7" cy="43.2" r="0.2"/>
<circle cx="66.4" cy="43.2" r="0.2"/>
<circle cx="67.2" cy="43.2" r="0.2"/>
<circle cx="67.9" cy="43.2" r="0.2"/>
<circle cx="68.6" cy="43.2" r="0.2"/>
<circle cx="69.4" cy="43.2" r="0.2"/>
<circle cx="70.1" cy="43.2" r="0.2"/>
<circle cx="70.9" cy="43.2" r="0.2"/>
<circle cx="71.6" cy="43.2" r="0.2"/>
<circle cx="72.3" cy="43.2" r="0.2"/>
<circle cx="73.1" cy="43.2" r="0.2"/>
<circle cx="73.8" cy="43.2" r="0.2"/>
<circle cx="74.6" cy="43.2" r="0.2"/>
<circle cx="75.3" cy="43.2" r="0.2"/>
<circle cx="76" cy="43.2" r="0.2"/>
<circle cx="76.8" cy="43.2" r="0.2"/>
<circle cx="77.5" cy="43.2" r="0.2"/>
<circle cx="78.3" cy="43.2" r="0.2"/>
<circle cx="79" cy="43.2" r="0.2"/>
<circle cx="79.7" cy="43.2" r="0.2"/>
<circle cx="80.5" cy="43.2" r="0.2"/>
<circle cx="81.2" cy="43.2" r="0.2"/>
<circle cx="82" cy="43.2" r="0.2"/>
<circle cx="82.7" cy="43.2" r="0.2"/>
<circle cx="83.4" cy="43.2" r="0.2"/>
<circle cx="84.2" cy="43.2" r="0.2"/>
<circle cx="84.9" cy="43.2" r="0.2"/>
<circle cx="85.6" cy="43.2" r="0.2"/>
<circle cx="86.4" cy="43.2" r="0.2"/>
<circle cx="87.1" cy="43.2" r="0.2"/>
<circle cx="87.9" cy="43.2" r="0.2"/>
<circle cx="88.6" cy="43.2" r="0.2"/>
<circle cx="89.3" cy="43.2" r="0.2"/>
<circle cx="90.1" cy="43.2" r="0.2"/>
<circle cx="90.8" cy="43.2" r="0.2"/>
<circle cx="91.6" cy="43.2" r="0.2"/>
<circle cx="92.3" cy="43.2" r="0.2"/>
<circle cx="50.2" cy="42.4" r="0.2"/>
<circle cx="50.9" cy="42.4" r="0.2"/>
<circle cx="51.6" cy="42.4" r="0.2"/>
<circle cx="52.4" cy="42.4" r="0.2"/>
<circle cx="53.9" cy="42.4" r="0.2"/>
<circle cx="54.6" cy="42.4" r="0.2"/>
<circle cx="55.3" cy="42.4" r="0.2"/>
<circle cx="56.1" cy="42.4" r="0.2"/>
<circle cx="56.8" cy="42.4" r="0.2"/>
<circle cx="57.6" cy="42.4" r="0.2"/>
<circle cx="58.3" cy="42.4" r="0.2"/>
<circle cx="59" cy="42.4" r="0.2"/>
<circle cx="59.8" cy="42.4" r="0.2"/>
<circle cx="60.5" cy="42.4" r="0.2"/>
<circle cx="61.3" cy="42.4" r="0.2"/>
<circle cx="62" cy="42.4" r="0.2"/>
<circle cx="62.7" cy="42.4" r="0.2"/>
<circle cx="63.5" cy="42.4" r="0.2"/>
<circle cx="64.2" cy="42.4" r="0.2"/>
<circle cx="64.9" cy="42.4" r="0.2"/>
<circle cx="65.7" cy="42.4" r="0.2"/>
<circle cx="66.4" cy="42.4" r="0.2"/>
<circle cx="67.2" cy="42.4" r="0.2"/>
<circle cx="67.9" cy="42.4" r="0.2"/>
<circle cx="68.6" cy="42.4" r="0.2"/>
<circle cx="69.4" cy="42.4" r="0.2"/>
<circle cx="70.1" cy="42.4" r="0.2"/>
<circle cx="70.9" cy="42.4" r="0.2"/>
<circle cx="71.6" cy="42.4" r="0.2"/>
<circle cx="72.3" cy="42.4" r="0.2"/>
<circle cx="73.1" cy="42.4" r="0.2"/>
<circle cx="73.8" cy="42.4" r="0.2"/>
<circle cx="74.6" cy="42.4" r="0.2"/>
<circle cx="75.3" cy="42.4" r="0.2"/>
<circle cx="76" cy="42.4" r="0.2"/>
<circle cx="76.8" cy="42.4" r="0.2"/>
<circle cx="77.5" cy="42.4" r="0.2"/>
<circle cx="78.3" cy="42.4" r="0.2"/>
<circle cx="79" cy="42.4" r="0.2"/>
<circle cx="79.7" cy="42.4" r="0.2"/>
<circle cx="80.5" cy="42.4" r="0.2"/>
<circle cx="81.2" cy="42.4" r="0.2"/>
<circle cx="82" cy="42.4" r="0.2"/>
<circle cx="82.7" cy="42.4" r="0.2"/>
<circle cx="83.4" cy="42.4" r="0.2"/>
<circle cx="84.2" cy="42.4" r="0.2"/>
<circle cx="84.9" cy="42.4" r="0.2"/>
<circle cx="85.7" cy="42.4" r="0.2"/>
<circle cx="86.4" cy="42.4" r="0.2"/>
<circle cx="87.1" cy="42.4" r="0.2"/>
<circle cx="87.9" cy="42.4" r="0.2"/>
<circle cx="88.6" cy="42.4" r="0.2"/>
<circle cx="89.3" cy="42.4" r="0.2"/>
<circle cx="90.1" cy="42.4" r="0.2"/>
<circle cx="90.8" cy="42.4" r="0.2"/>
<circle cx="91.6" cy="42.4" r="0.2"/>
<circle cx="50.9" cy="41.7" r="0.2"/>
<circle cx="51.6" cy="41.7" r="0.2"/>
<circle cx="52.4" cy="41.7" r="0.2"/>
<circle cx="53.9" cy="41.7" r="0.2"/>
<circle cx="54.6" cy="41.7" r="0.2"/>
<circle cx="55.3" cy="41.7" r="0.2"/>
<circle cx="58.3" cy="41.7" r="0.2"/>
<circle cx="59" cy="41.7" r="0.2"/>
<circle cx="59.8" cy="41.7" r="0.2"/>
<circle cx="60.5" cy="41.7" r="0.2"/>
<circle cx="61.3" cy="41.7" r="0.2"/>
<circle cx="62" cy="41.7" r="0.2"/>
<circle cx="62.7" cy="41.7" r="0.2"/>
<circle cx="63.5" cy="41.7" r="0.2"/>
<circle cx="64.2" cy="41.7" r="0.2"/>
<circle cx="64.9" cy="41.7" r="0.2"/>
<circle cx="65.7" cy="41.7" r="0.2"/>
<circle cx="66.4" cy="41.7" r="0.2"/>
<circle cx="67.2" cy="41.7" r="0.2"/>
<circle cx="67.9" cy="41.7" r="0.2"/>
<circle cx="68.6" cy="41.7" r="0.2"/>
<circle cx="69.4" cy="41.7" r="0.2"/>
<circle cx="70.1" cy="41.7" r="0.2"/>
<circle cx="70.9" cy="41.7" r="0.2"/>
<circle cx="71.6" cy="41.7" r="0.2"/>
<circle cx="72.3" cy="41.7" r="0.2"/>
<circle cx="73.1" cy="41.7" r="0.2"/>
<circle cx="73.8" cy="41.7" r="0.2"/>
<circle cx="74.6" cy="41.7" r="0.2"/>
<circle cx="75.3" cy="41.7" r="0.2"/>
<circle cx="76" cy="41.7" r="0.2"/>
<circle cx="76.8" cy="41.7" r="0.2"/>
<circle cx="77.5" cy="41.7" r="0.2"/>
<circle cx="78.3" cy="41.7" r="0.2"/>
<circle cx="79" cy="41.7" r="0.2"/>
<circle cx="79.7" cy="41.7" r="0.2"/>
<circle cx="80.5" cy="41.7" r="0.2"/>
<circle cx="81.2" cy="41.7" r="0.2"/>
<circle cx="82" cy="41.7" r="0.2"/>
<circle cx="82.7" cy="41.7" r="0.2"/>
<circle cx="83.4" cy="41.7" r="0.2"/>
<circle cx="84.2" cy="41.7" r="0.2"/>
<circle cx="84.9" cy="41.7" r="0.2"/>
<circle cx="85.7" cy="41.7" r="0.2"/>
<circle cx="86.4" cy="41.7" r="0.2"/>
<circle cx="87.1" cy="41.7" r="0.2"/>
<circle cx="87.9" cy="41.7" r="0.2"/>
<circle cx="88.6" cy="41.7" r="0.2"/>
<circle cx="89.3" cy="41.7" r="0.2"/>
<circle cx="90.1" cy="41.7" r="0.2"/>
<circle cx="90.8" cy="41.7" r="0.2"/>
<circle cx="91.6" cy="41.7" r="0.2"/>
<circle cx="92.3" cy="41.7" r="0.2"/>
<circle cx="93.1" cy="41.7" r="0.2"/>
<circle cx="93.8" cy="41.7" r="0.2"/>
<circle cx="94.5" cy="41.7" r="0.2"/>
<circle cx="50.9" cy="41" r="0.2"/>
<circle cx="51.6" cy="41" r="0.2"/>
<circle cx="52.4" cy="41" r="0.2"/>
<circle cx="53.1" cy="41" r="0.2"/>
<circle cx="53.9" cy="41" r="0.2"/>
<circle cx="54.6" cy="41" r="0.2"/>
<circle cx="55.3" cy="41" r="0.2"/>
<circle cx="56.1" cy="41" r="0.2"/>
<circle cx="56.8" cy="41" r="0.2"/>
<circle cx="57.6" cy="41" r="0.2"/>
<circle cx="59.8" cy="41" r="0.2"/>
<circle cx="60.5" cy="41" r="0.2"/>
<circle cx="61.3" cy="41" r="0.2"/>
<circle cx="62" cy="41" r="0.2"/>
<circle cx="62.7" cy="41" r="0.2"/>
<circle cx="63.5" cy="41" r="0.2"/>
<circle cx="64.2" cy="41" r="0.2"/>
<circle cx="64.9" cy="41" r="0.2"/>
<circle cx="65.7" cy="41" r="0.2"/>
<circle cx="66.4" cy="41" r="0.2"/>
<circle cx="67.2" cy="41" r="0.2"/>
<circle cx="67.9" cy="41" r="0.2"/>
<circle cx="68.6" cy="41" r="0.2"/>
<circle cx="69.4" cy="41" r="0.2"/>
<circle cx="70.1" cy="41" r="0.2"/>
<circle cx="70.9" cy="41" r="0.2"/>
<circle cx="71.6" cy="41" r="0.2"/>
<circle cx="72.3" cy="41" r="0.2"/>
<circle cx="73.1" cy="41" r="0.2"/>
<circle cx="73.8" cy="41" r="0.2"/>
<circle cx="74.6" cy="41" r="0.2"/>
<circle cx="75.3" cy="41" r="0.2"/>
<circle cx="76" cy="41" r="0.2"/>
<circle cx="76.8" cy="41" r="0.2"/>
<circle cx="77.5" cy="41" r="0.2"/>
<circle cx="78.3" cy="41" r="0.2"/>
<circle cx="79" cy="41" r="0.2"/>
<circle cx="79.7" cy="41" r="0.2"/>
<circle cx="80.5" cy="41" r="0.2"/>
<circle cx="81.2" cy="41" r="0.2"/>
<circle cx="82" cy="41" r="0.2"/>
<circle cx="82.7" cy="41" r="0.2"/>
<circle cx="83.4" cy="41" r="0.2"/>
<circle cx="84.2" cy="41" r="0.2"/>
<circle cx="84.9" cy="41" r="0.2"/>
<circle cx="85.7" cy="41" r="0.2"/>
<circle cx="86.4" cy="41" r="0.2"/>
<circle cx="87.1" cy="41" r="0.2"/>
<circle cx="87.9" cy="41" r="0.2"/>
<circle cx="88.6" cy="41" r="0.2"/>
<circle cx="89.3" cy="41" r="0.2"/>
<circle cx="90.1" cy="41" r="0.2"/>
<circle cx="90.8" cy="41" r="0.2"/>
<circle cx="91.6" cy="41" r="0.2"/>
<circle cx="92.3" cy="41" r="0.2"/>
<circle cx="93.1" cy="41" r="0.2"/>
<circle cx="93.8" cy="41" r="0.2"/>
<circle cx="94.5" cy="41" r="0.2"/>
<circle cx="95.3" cy="41" r="0.2"/>
<circle cx="51.6" cy="40.2" r="0.2"/>
<circle cx="52.4" cy="40.2" r="0.2"/>
<circle cx="53.1" cy="40.2" r="0.2"/>
<circle cx="53.9" cy="40.2" r="0.2"/>
<circle cx="54.6" cy="40.2" r="0.2"/>
<circle cx="55.3" cy="40.2" r="0.2"/>
<circle cx="56.1" cy="40.2" r="0.2"/>
<circle cx="56.8" cy="40.2" r="0.2"/>
<circle cx="59" cy="40.2" r="0.2"/>
<circle cx="60.5" cy="40.2" r="0.2"/>
<circle cx="61.3" cy="40.2" r="0.2"/>
<circle cx="62" cy="40.2" r="0.2"/>
<circle cx="62.7" cy="40.2" r="0.2"/>
<circle cx="63.5" cy="40.2" r="0.2"/>
<circle cx="64.2" cy="40.2" r="0.2"/>
<circle cx="64.9" cy="40.2" r="0.2"/>
<circle cx="65.7" cy="40.2" r="0.2"/>
<circle cx="66.4" cy="40.2" r="0.2"/>
<circle cx="67.2" cy="40.2" r="0.2"/>
<circle cx="67.9" cy="40.2" r="0.2"/>
<circle cx="68.6" cy="40.2" r="0.2"/>
<circle cx="69.4" cy="40.2" r="0.2"/>
<circle cx="70.1" cy="40.2" r="0.2"/>
<circle cx="70.9" cy="40.2" r="0.2"/>
<circle cx="71.6" cy="40.2" r="0.2"/>
<circle cx="72.3" cy="40.2" r="0.2"/>
<circle cx="73.1" cy="40.2" r="0.2"/>
<circle cx="73.8" cy="40.2" r="0.2"/>
<circle cx="74.6" cy="40.2" r="0.2"/>
<circle cx="75.3" cy="40.2" r="0.2"/>
<circle cx="76" cy="40.2" r="0.2"/>
<circle cx="76.8" cy="40.2" r="0.2"/>
<circle cx="77.5" cy="40.2" r="0.2"/>
<circle cx="78.3" cy="40.2" r="0.2"/>
<circle cx="79" cy="40.2" r="0.2"/>
<circle cx="79.7" cy="40.2" r="0.2"/>
<circle cx="80.5" cy="40.2" r="0.2"/>
<circle cx="81.2" cy="40.2" r="0.2"/>
<circle cx="82" cy="40.2" r="0.2"/>
<circle cx="82.7" cy="40.2" r="0.2"/>
<circle cx="83.4" cy="40.2" r="0.2"/>
<circle cx="84.2" cy="40.2" r="0.2"/>
<circle cx="84.9" cy="40.2" r="0.2"/>
<circle cx="85.7" cy="40.2" r="0.2"/>
<circle cx="86.4" cy="40.2" r="0.2"/>
<circle cx="87.1" cy="40.2" r="0.2"/>
<circle cx="87.9" cy="40.2" r="0.2"/>
<circle cx="88.6" cy="40.2" r="0.2"/>
<circle cx="89.3" cy="40.2" r="0.2"/>
<circle cx="90.1" cy="40.2" r="0.2"/>
<circle cx="90.8" cy="40.2" r="0.2"/>
<circle cx="91.6" cy="40.2" r="0.2"/>
<circle cx="92.3" cy="40.2" r="0.2"/>
<circle cx="93.1" cy="40.2" r="0.2"/>
<circle cx="93.8" cy="40.2" r="0.2"/>
<circle cx="51.6" cy="39.5" r="0.2"/>
<circle cx="52.4" cy="39.5" r="0.2"/>
<circle cx="53.1" cy="39.5" r="0.2"/>
<circle cx="53.9" cy="39.5" r="0.2"/>
<circle cx="54.6" cy="39.5" r="0.2"/>
<circle cx="55.3" cy="39.5" r="0.2"/>
<circle cx="56.1" cy="39.5" r="0.2"/>
<circle cx="56.8" cy="39.5" r="0.2"/>
<circle cx="62.7" cy="39.5" r="0.2"/>
<circle cx="63.5" cy="39.5" r="0.2"/>
<circle cx="64.9" cy="39.5" r="0.2"/>
<circle cx="65.7" cy="39.5" r="0.2"/>
<circle cx="66.4" cy="39.5" r="0.2"/>
<circle cx="67.2" cy="39.5" r="0.2"/>
<circle cx="67.9" cy="39.5" r="0.2"/>
<circle cx="68.6" cy="39.5" r="0.2"/>
<circle cx="69.4" cy="39.5" r="0.2"/>
<circle cx="70.1" cy="39.5" r="0.2"/>
<circle cx="70.9" cy="39.5" r="0.2"/>
<circle cx="71.6" cy="39.5" r="0.2"/>
<circle cx="72.3" cy="39.5" r="0.2"/>
<circle cx="73.1" cy="39.5" r="0.2"/>
<circle cx="73.8" cy="39.5" r="0.2"/>
<circle cx="74.6" cy="39.5" r="0.2"/>
<circle cx="75.3" cy="39.5" r="0.2"/>
<circle cx="76" cy="39.5" r="0.2"/>
<circle cx="76.8" cy="39.5" r="0.2"/>
<circle cx="77.5" cy="39.5" r="0.2"/>
<circle cx="78.3" cy="39.5" r="0.2"/>
<circle cx="79" cy="39.5" r="0.2"/>
<circle cx="79.7" cy="39.5" r="0.2"/>
<circle cx="80.5" cy="39.5" r="0.2"/>
<circle cx="81.2" cy="39.5" r="0.2"/>
<circle cx="82" cy="39.5" r="0.2"/>
<circle cx="82.7" cy="39.5" r="0.2"/>
<circle cx="83.4" cy="39.5" r="0.2"/>
<circle cx="84.2" cy="39.5" r="0.2"/>
<circle cx="84.9" cy="39.5" r="0.2"/>
<circle cx="85.7" cy="39.5" r="0.2"/>
<circle cx="86.4" cy="39.5" r="0.2"/>
<circle cx="87.1" cy="39.5" r="0.2"/>
<circle cx="87.9" cy="39.5" r="0.2"/>
<circle cx="88.6" cy="39.5" r="0.2"/>
<circle cx="89.3" cy="39.5" r="0.2"/>
<circle cx="90.1" cy="39.5" r="0.2"/>
<circle cx="90.8" cy="39.5" r="0.2"/>
<circle cx="91.6" cy="39.5" r="0.2"/>
<circle cx="92.3" cy="39.5" r="0.2"/>
<circle cx="93.1" cy="39.5" r="0.2"/>
<circle cx="53.1" cy="38.7" r="0.2"/>
<circle cx="53.9" cy="38.7" r="0.2"/>
<circle cx="54.6" cy="38.7" r="0.2"/>
<circle cx="64.9" cy="38.7" r="0.2"/>
<circle cx="65.7" cy="38.7" r="0.2"/>
<circle cx="66.4" cy="38.7" r="0.2"/>
<circle cx="67.2" cy="38.7" r="0.2"/>
<circle cx="67.9" cy="38.7" r="0.2"/>
<circle cx="68.6" cy="38.7" r="0.2"/>
<circle cx="69.4" cy="38.7" r="0.2"/>
<circle cx="70.1" cy="38.7" r="0.2"/>
<circle cx="70.9" cy="38.7" r="0.2"/>
<circle cx="71.6" cy="38.7" r="0.2"/>
<circle cx="72.3" cy="38.7" r="0.2"/>
<circle cx="73.1" cy="38.7" r="0.2"/>
<circle cx="73.8" cy="38.7" r="0.2"/>
<circle cx="74.6" cy="38.7" r="0.2"/>
<circle cx="75.3" cy="38.7" r="0.2"/>
<circle cx="76" cy="38.7" r="0.2"/>
<circle cx="76.8" cy="38.7" r="0.2"/>
<circle cx="77.5" cy="38.7" r="0.2"/>
<circle cx="78.3" cy="38.7" r="0.2"/>
<circle cx="79" cy="38.7" r="0.2"/>
<circle cx="79.7" cy="38.7" r="0.2"/>
<circle cx="80.5" cy="38.7" r="0.2"/>
<circle cx="81.2" cy="38.7" r="0.2"/>
<circle cx="82" cy="38.7" r="0.2"/>
<circle cx="82.7" cy="38.7" r="0.2"/>
<circle cx="83.4" cy="38.7" r="0.2"/>
<circle cx="84.2" cy="38.7" r="0.2"/>
<circle cx="84.9" cy="38.7" r="0.2"/>
<circle cx="85.7" cy="38.7" r="0.2"/>
<circle cx="86.4" cy="38.7" r="0.2"/>
<circle cx="87.1" cy="38.7" r="0.2"/>
<circle cx="87.9" cy="38.7" r="0.2"/>
<circle cx="90.8" cy="38.7" r="0.2"/>
<circle cx="53.9" cy="38" r="0.2"/>
<circle cx="64.2" cy="38" r="0.2"/>
<circle cx="64.9" cy="38" r="0.2"/>
<circle cx="65.7" cy="38" r="0.2"/>
<circle cx="66.4" cy="38" r="0.2"/>
<circle cx="67.2" cy="38" r="0.2"/>
<circle cx="67.9" cy="38" r="0.2"/>
<circle cx="68.6" cy="38" r="0.2"/>
<circle cx="69.4" cy="38" r="0.2"/>
<circle cx="70.1" cy="38" r="0.2"/>
<circle cx="70.9" cy="38" r="0.2"/>
<circle cx="71.6" cy="38" r="0.2"/>
<circle cx="72.3" cy="38" r="0.2"/>
<circle cx="73.1" cy="38" r="0.2"/>
<circle cx="73.8" cy="38" r="0.2"/>
<circle cx="74.6" cy="38" r="0.2"/>
<circle cx="75.3" cy="38" r="0.2"/>
<circle cx="76" cy="38" r="0.2"/>
<circle cx="76.8" cy="38" r="0.2"/>
<circle cx="77.5" cy="38" r="0.2"/>
<circle cx="78.3" cy="38" r="0.2"/>
<circle cx="79" cy="38" r="0.2"/>
<circle cx="79.7" cy="38" r="0.2"/>
<circle cx="80.5" cy="38" r="0.2"/>
<circle cx="81.2" cy="38" r="0.2"/>
<circle cx="82" cy="38" r="0.2"/>
<circle cx="82.7" cy="38" r="0.2"/>
<circle cx="83.4" cy="38" r="0.2"/>
<circle cx="84.2" cy="38" r="0.2"/>
<circle cx="84.9" cy="38" r="0.2"/>
<circle cx="85.7" cy="38" r="0.2"/>
<circle cx="87.1" cy="38" r="0.2"/>
<circle cx="64.9" cy="37.3" r="0.2"/>
<circle cx="65.7" cy="37.3" r="0.2"/>
<circle cx="66.4" cy="37.3" r="0.2"/>
<circle cx="67.2" cy="37.3" r="0.2"/>
<circle cx="68.6" cy="37.3" r="0.2"/>
<circle cx="69.4" cy="37.3" r="0.2"/>
<circle cx="70.1" cy="37.3" r="0.2"/>
<circle cx="70.9" cy="37.3" r="0.2"/>
<circle cx="71.6" cy="37.3" r="0.2"/>
<circle cx="72.3" cy="37.3" r="0.2"/>
<circle cx="73.1" cy="37.3" r="0.2"/>
<circle cx="73.8" cy="37.3" r="0.2"/>
<circle cx="74.6" cy="37.3" r="0.2"/>
<circle cx="75.3" cy="37.3" r="0.2"/>
<circle cx="76" cy="37.3" r="0.2"/>
<circle cx="76.8" cy="37.3" r="0.2"/>
<circle cx="77.5" cy="37.3" r="0.2"/>
<circle cx="78.3" cy="37.3" r="0.2"/>
<circle cx="79" cy="37.3" r="0.2"/>
<circle cx="79.7" cy="37.3" r="0.2"/>
<circle cx="83.4" cy="37.3" r="0.2"/>
<circle cx="84.2" cy="37.3" r="0.2"/>
<circle cx="84.9" cy="37.3" r="0.2"/>
<circle cx="64.9" cy="36.5" r="0.2"/>
<circle cx="65.7" cy="36.5" r="0.2"/>
<circle cx="67.9" cy="36.5" r="0.2"/>
<circle cx="68.6" cy="36.5" r="0.2"/>
<circle cx="69.4" cy="36.5" r="0.2"/>
<circle cx="70.1" cy="36.5" r="0.2"/>
<circle cx="70.9" cy="36.5" r="0.2"/>
<circle cx="71.6" cy="36.5" r="0.2"/>
<circle cx="72.3" cy="36.5" r="0.2"/>
<circle cx="73.1" cy="36.5" r="0.2"/>
<circle cx="73.8" cy="36.5" r="0.2"/>
<circle cx="74.6" cy="36.5" r="0.2"/>
<circle cx="75.3" cy="36.5" r="0.2"/>
<circle cx="76" cy="36.5" r="0.2"/>
<circle cx="76.8" cy="36.5" r="0.2"/>
<circle cx="77.5" cy="36.5" r="0.2"/>
<circle cx="78.3" cy="36.5" r="0.2"/>
<circle cx="79" cy="36.5" r="0.2"/>
<circle cx="79.7" cy="36.5" r="0.2"/>
<circle cx="83.4" cy="36.5" r="0.2"/>
<circle cx="69.4" cy="35.8" r="0.2"/>
<circle cx="70.1" cy="35.8" r="0.2"/>
<circle cx="70.9" cy="35.8" r="0.2"/>
<circle cx="71.6" cy="35.8" r="0.2"/>
<circle cx="72.3" cy="35.8" r="0.2"/>
<circle cx="73.1" cy="35.8" r="0.2"/>
<circle cx="73.8" cy="35.8" r="0.2"/>
<circle cx="74.6" cy="35.8" r="0.2"/>
<circle cx="75.3" cy="35.8" r="0.2"/>
<circle cx="76.8" cy="35.8" r="0.2"/>
<circle cx="79" cy="35.8" r="0.2"/>
<circle cx="69.4" cy="35" r="0.2"/>
<circle cx="70.1" cy="35" r="0.2"/>
<circle cx="70.9" cy="35" r="0.2"/>
<circle cx="71.6" cy="35" r="0.2"/>
<circle cx="72.3" cy="35" r="0.2"/>
<circle cx="73.1" cy="35" r="0.2"/>
<circle cx="73.8" cy="35" r="0.2"/>
<circle cx="74.6" cy="35" r="0.2"/>
<circle cx="75.3" cy="35" r="0.2"/>
<circle cx="70.1" cy="34.3" r="0.2"/>
<circle cx="70.9" cy="34.3" r="0.2"/>
<circle cx="71.6" cy="34.3" r="0.2"/>
<circle cx="72.3" cy="34.3" r="0.2"/>
<circle cx="73.1" cy="34.3" r="0.2"/>
<circle cx="73.8" cy="34.3" r="0.2"/>
<circle cx="74.6" cy="34.3" r="0.2"/>
<circle cx="75.3" cy="34.3" r="0.2"/>
<circle cx="76" cy="34.3" r="0.2"/>
<circle cx="71.6" cy="33.6" r="0.2"/>
<circle cx="72.3" cy="33.6" r="0.2"/>
<circle cx="73.1" cy="33.6" r="0.2"/>
<circle cx="73.8" cy="33.6" r="0.2"/>
<circle cx="74.6" cy="33.6" r="0.2"/>
<circle cx="75.3" cy="33.6" r="0.2"/>
<circle cx="76" cy="33.6" r="0.2"/>
<circle cx="71.6" cy="32.8" r="0.2"/>
<circle cx="72.3" cy="32.8" r="0.2"/>
<circle cx="73.1" cy="32.8" r="0.2"/>
<circle cx="73.8" cy="32.8" r="0.2"/>
<circle cx="74.6" cy="32.8" r="0.2"/>
<circle cx="73.8" cy="32.1" r="0.2"/>
<circle cx="75.3" cy="32.8" r="0.2"/>
</g>
</svg>
`;
